// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by generate_cabin_images.py

export const cabinImages: { [shipCode: string]: { [cabinCode: string]: (() => Promise<string>)[] } } = {
  "MSC_FA": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_FA/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/IR1/2.jpg?url").then(m => m.default),
    ],
    "OL1": [
      () => import("@/assets/imgs/cabins/MSC_FA/OL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/OL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/OL1/3.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_FA/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BA/4.jpg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_FA/YCT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YCT/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YCT/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YCT/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YCT/5.jpg?url").then(m => m.default),
    ],
    "SX": [
      () => import("@/assets/imgs/cabins/MSC_FA/SX/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/SX/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/SX/3.jpg?url").then(m => m.default),
    ],
    "YCP": [
      () => import("@/assets/imgs/cabins/MSC_FA/YCP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YCP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YCP/3.jpg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_FA/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YC1/2.jpg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_FA/YC3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YC3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YC3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YC3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YC3/5.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_FA/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/IR2/2.jpg?url").then(m => m.default),
    ],
    "BL3": [
      () => import("@/assets/imgs/cabins/MSC_FA/BL3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BL3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BL3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BL3/4.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_FA/IB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/IB/2.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_FA/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/OB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/OB/3.jpg?url").then(m => m.default),
    ],
    "SRS": [
      () => import("@/assets/imgs/cabins/MSC_FA/SRS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/SRS/2.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_FA/SL1/1.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_FA/BP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BP/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BP/4.jpg?url").then(m => m.default),
    ],
    "YC2": [
      () => import("@/assets/imgs/cabins/MSC_FA/YC2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YC2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YC2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/YC2/4.jpg?url").then(m => m.default),
    ],
    "OL3": [
      () => import("@/assets/imgs/cabins/MSC_FA/OL3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/OL3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/OL3/3.jpg?url").then(m => m.default),
    ],
    "BL1": [
      () => import("@/assets/imgs/cabins/MSC_FA/BL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BL1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BL1/4.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_FA/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BB/4.jpg?url").then(m => m.default),
    ],
    "SLS": [
      () => import("@/assets/imgs/cabins/MSC_FA/SLS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/SLS/2.jpg?url").then(m => m.default),
    ],
    "OL2": [
      () => import("@/assets/imgs/cabins/MSC_FA/OL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/OL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/OL2/3.jpg?url").then(m => m.default),
    ],
    "BL2": [
      () => import("@/assets/imgs/cabins/MSC_FA/BL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BL2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_FA/BL2/4.jpg?url").then(m => m.default),
    ],
  },
  "MSC_AR": {
    "OL1": [
      () => import("@/assets/imgs/cabins/MSC_AR/OL1/2.jpg?url").then(m => m.default),
    ],
    "OO": [
      () => import("@/assets/imgs/cabins/MSC_AR/OO/1.jpg?url").then(m => m.default),
    ],
    "IM2": [
      () => import("@/assets/imgs/cabins/MSC_AR/IM2/1.jpg?url").then(m => m.default),
    ],
    "OM2": [
      () => import("@/assets/imgs/cabins/MSC_AR/OM2/1.jpg?url").then(m => m.default),
    ],
    "SR1": [
      () => import("@/assets/imgs/cabins/MSC_AR/SR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AR/SR1/2.jpg?url").then(m => m.default),
    ],
    "IM1": [
      () => import("@/assets/imgs/cabins/MSC_AR/IM1/1.jpg?url").then(m => m.default),
    ],
    "SR2": [
      () => import("@/assets/imgs/cabins/MSC_AR/SR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AR/SR2/2.jpg?url").then(m => m.default),
    ],
    "OM1": [
      () => import("@/assets/imgs/cabins/MSC_AR/OM1/1.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_AR/IB/1.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_AR/OB/1.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_AR/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AR/BB/2.jpg?url").then(m => m.default),
    ],
    "BM1": [
      () => import("@/assets/imgs/cabins/MSC_AR/BM1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AR/BM1/2.jpg?url").then(m => m.default),
    ],
  },
  "LU": {
    "EP": [
      () => import("@/assets/imgs/cabins/LU/EP/EP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/EP/EP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/EP/EP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/EP/EP4.jpeg?url").then(m => m.default),
    ],
    "I3": [
      () => import("@/assets/imgs/cabins/LU/I3/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I3/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I3/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I3/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I3/I5.jpeg?url").then(m => m.default),
    ],
    "S": [
      () => import("@/assets/imgs/cabins/LU/S/S1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/S/S2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/S/S3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/S/S4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/S/S5.jpeg?url").then(m => m.default),
    ],
    "B2": [
      () => import("@/assets/imgs/cabins/LU/B2/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B2/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B2/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B2/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B2/B5.jpeg?url").then(m => m.default),
    ],
    "B3": [
      () => import("@/assets/imgs/cabins/LU/B3/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B3/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B3/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B3/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B3/B5.jpeg?url").then(m => m.default),
    ],
    "IV": [
      () => import("@/assets/imgs/cabins/LU/IV/IV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/IV/IV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/IV/IV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/IV/IV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/IV/IV5.jpeg?url").then(m => m.default),
    ],
    "E1": [
      () => import("@/assets/imgs/cabins/LU/E1/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/E1/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/E1/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/E1/E4.jpeg?url").then(m => m.default),
    ],
    "I4": [
      () => import("@/assets/imgs/cabins/LU/I4/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I4/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I4/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I4/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I4/I5.jpeg?url").then(m => m.default),
    ],
    "BC": [
      () => import("@/assets/imgs/cabins/LU/BC/BC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/BC/BC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/BC/BC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/BC/BC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/BC/BC5.jpeg?url").then(m => m.default),
    ],
    "MS": [
      () => import("@/assets/imgs/cabins/LU/MS/MS1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/MS/MS2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/MS/MS3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/MS/MS4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/MS/MS5.jpeg?url").then(m => m.default),
    ],
    "I1": [
      () => import("@/assets/imgs/cabins/LU/I1/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I1/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I1/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I1/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I1/I5.jpeg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/LU/BP/BP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/BP/BP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/BP/BP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/BP/BP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/BP/BP5.jpeg?url").then(m => m.default),
    ],
    "B1": [
      () => import("@/assets/imgs/cabins/LU/B1/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B1/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B1/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B1/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B1/B5.jpeg?url").then(m => m.default),
    ],
    "EC": [
      () => import("@/assets/imgs/cabins/LU/EC/EC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/EC/EC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/EC/EC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/EC/EC4.jpeg?url").then(m => m.default),
    ],
    "IP": [
      () => import("@/assets/imgs/cabins/LU/IP/IP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/IP/IP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/IP/IP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/IP/IP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/IP/IP5.jpeg?url").then(m => m.default),
    ],
    "EV": [
      () => import("@/assets/imgs/cabins/LU/EV/EV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/EV/EV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/EV/EV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/EV/EV4.jpeg?url").then(m => m.default),
    ],
    "BV": [
      () => import("@/assets/imgs/cabins/LU/BV/BV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/BV/BV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/BV/BV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/BV/BV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/BV/BV5.jpeg?url").then(m => m.default),
    ],
    "I2": [
      () => import("@/assets/imgs/cabins/LU/I2/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I2/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I2/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I2/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/I2/I5.jpeg?url").then(m => m.default),
    ],
    "IC": [
      () => import("@/assets/imgs/cabins/LU/IC/IC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/IC/IC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/IC/IC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/IC/IC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/IC/IC5.jpeg?url").then(m => m.default),
    ],
    "B4": [
      () => import("@/assets/imgs/cabins/LU/B4/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B4/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B4/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B4/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/B4/B5.jpeg?url").then(m => m.default),
    ],
    "GS": [
      () => import("@/assets/imgs/cabins/LU/GS/GS1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/GS/GS2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/GS/GS3.jpg?url").then(m => m.default),
    ],
    "E2": [
      () => import("@/assets/imgs/cabins/LU/E2/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/E2/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/E2/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/LU/E2/E4.jpeg?url").then(m => m.default),
    ],
  },
  "MSC_AM": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_AM/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/IR1/2.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_AM/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BA/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BA/5.jpg?url").then(m => m.default),
    ],
    "YCD": [
      () => import("@/assets/imgs/cabins/MSC_AM/YCD/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YCD/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YCD/2.jpg.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YCD/3.jpg?url").then(m => m.default),
    ],
    "SXT": [
      () => import("@/assets/imgs/cabins/MSC_AM/SXT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/SXT/sxt-grand-suite-aurea-with-terrace-2.jpg?url").then(m => m.default),
    ],
    "OS": [
      () => import("@/assets/imgs/cabins/MSC_AM/OS/1.jpg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_AM/YCT/msc-yacht-club-royal-suite-with-whirlpool-bath_yc3_700x433.jpg.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YCT/yc3-royal-suite.jpg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_AM/BR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BR2/2.jpg?url").then(m => m.default),
    ],
    "SX": [
      () => import("@/assets/imgs/cabins/MSC_AM/SX/1.jpg?url").then(m => m.default),
    ],
    "PR2": [
      () => import("@/assets/imgs/cabins/MSC_AM/PR2/1 2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/PR2/1.jpg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_AM/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YC1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YC1/3.jpg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_AM/YC3/msc-yacht-club-royal-suite-with-whirlpool-bath_yc3_700x433.jpg.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YC3/yc3-royal-suite.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_AM/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/IR2/2.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_AM/IB/1 2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/IB/1.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_AM/OB/1.jpg?url").then(m => m.default),
    ],
    "PR1": [
      () => import("@/assets/imgs/cabins/MSC_AM/PR1/1 2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/PR1/1.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_AM/SL1/1.jpg?url").then(m => m.default),
    ],
    "BR3": [
      () => import("@/assets/imgs/cabins/MSC_AM/BR3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BR3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BR3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BR3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BR3/5.jpg?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_AM/BR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BR1/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BR1/5.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_AM/BP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BP/2.jpg?url").then(m => m.default),
    ],
    "SRP": [
      () => import("@/assets/imgs/cabins/MSC_AM/SRP/srp-deluxe-suite-aurea-promenade-and-ocean-view.jpg?url").then(m => m.default),
    ],
    "VLA": [
      () => import("@/assets/imgs/cabins/MSC_AM/VLA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/VLA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/VLA/3.jpg?url").then(m => m.default),
    ],
    "IS": [
      () => import("@/assets/imgs/cabins/MSC_AM/IS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/IS/2.jpg?url").then(m => m.default),
    ],
    "PR3": [
      () => import("@/assets/imgs/cabins/MSC_AM/PR3/1.jpg?url").then(m => m.default),
    ],
    "SM": [
      () => import("@/assets/imgs/cabins/MSC_AM/SM/1.jpg?url").then(m => m.default),
    ],
    "PV": [
      () => import("@/assets/imgs/cabins/MSC_AM/PV/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/PV/2.jpg?url").then(m => m.default),
    ],
    "BGA": [
      () => import("@/assets/imgs/cabins/MSC_AM/BGA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BGA/2.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_AM/BB/1 2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BB/1 3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BB/2.jpg?url").then(m => m.default),
    ],
    "OR2": [
      () => import("@/assets/imgs/cabins/MSC_AM/OR2/1.jpg?url").then(m => m.default),
    ],
    "SXJ": [
      () => import("@/assets/imgs/cabins/MSC_AM/SXJ/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/SXJ/2.jpg?url").then(m => m.default),
    ],
    "YC4": [
      () => import("@/assets/imgs/cabins/MSC_AM/YC4/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YC4/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YC4/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YC4/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YC4/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YC4/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YC4/7.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YC4/8.jpg?url").then(m => m.default),
    ],
    "YJD": [
      () => import("@/assets/imgs/cabins/MSC_AM/YJD/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YJD/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YJD/3.jpg.jpg?url").then(m => m.default),
    ],
    "VL1": [
      () => import("@/assets/imgs/cabins/MSC_AM/VL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/VL1/2 2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/VL1/3.jpg?url").then(m => m.default),
    ],
    "BR4": [
      () => import("@/assets/imgs/cabins/MSC_AM/BR4/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BR4/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BR4/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BR4/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/BR4/5.jpg?url").then(m => m.default),
    ],
    "YIN": [
      () => import("@/assets/imgs/cabins/MSC_AM/YIN/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/YIN/2.jpg?url").then(m => m.default),
    ],
    "SLP": [
      () => import("@/assets/imgs/cabins/MSC_AM/SLP/slp-premium-suite-aurea-with-promenade-and-ocean-view.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_AM/SLP/srp-deluxe-suite-aurea-promenade-and-ocean-view.jpg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_AM/OR1/1.jpg?url").then(m => m.default),
    ],
  },
  "MSC_BE": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_BE/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/IR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/IR1/3.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_BE/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BA/4.jpg?url").then(m => m.default),
    ],
    "OO": [
      () => import("@/assets/imgs/cabins/MSC_BE/OO/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OO/2.jpg?url").then(m => m.default),
    ],
    "OM2": [
      () => import("@/assets/imgs/cabins/MSC_BE/OM2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OM2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OM2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OM2/4.jpg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_BE/YCT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YCT/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YCT/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YCT/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YCT/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YCT/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YCT/7.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YCT/8.jpg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_BE/BR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BR2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BR2/4.jpg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_BE/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YC1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YC1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YC1/4.jpg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_BE/YC3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YC3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YC3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YC3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YC3/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YC3/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YC3/7.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YC3/8.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_BE/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/IR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/IR2/3.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_BE/IB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/IB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/IB/3.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_BE/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OB/4.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_BE/SL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/SL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/SL1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/SL1/sl1_premium_suite_aurea_expandible_desktop_700x433_square.jpg?url").then(m => m.default),
    ],
    "BR3": [
      () => import("@/assets/imgs/cabins/MSC_BE/BR3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BR3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BR3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BR3/4.jpg?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_BE/BR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BR1/4.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_BE/BP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BP/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BP/4.jpg?url").then(m => m.default),
    ],
    "IS": [
      () => import("@/assets/imgs/cabins/MSC_BE/IS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/IS/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/IS/3.jpg?url").then(m => m.default),
    ],
    "SLJ": [
      () => import("@/assets/imgs/cabins/MSC_BE/SLJ/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/SLJ/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/SLJ/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/SLJ/slj_premium_suite_aurea_with_terrace_and_whirlpool_expandible_dextop_700x433_square.jpg?url").then(m => m.default),
    ],
    "BS": [
      () => import("@/assets/imgs/cabins/MSC_BE/BS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BS/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BS/3.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_BE/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/BB/4.jpg?url").then(m => m.default),
    ],
    "SXJ": [
      () => import("@/assets/imgs/cabins/MSC_BE/SXJ/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/SXJ/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/SXJ/SXJ.jpg?url").then(m => m.default),
    ],
    "YJD": [
      () => import("@/assets/imgs/cabins/MSC_BE/YJD/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YJD/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YJD/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YJD/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YJD/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YJD/6.jpg?url").then(m => m.default),
    ],
    "OL2": [
      () => import("@/assets/imgs/cabins/MSC_BE/OL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OL2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OL2/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OL2/5.jpg?url").then(m => m.default),
    ],
    "YIN": [
      () => import("@/assets/imgs/cabins/MSC_BE/YIN/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YIN/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YIN/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/YIN/4.jpg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_BE/OR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_BE/OR1/4.jpg?url").then(m => m.default),
    ],
  },
  "MSC_OP": {
    "OL1": [
      () => import("@/assets/imgs/cabins/MSC_OP/OL1/1.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_OP/BA/1.jpg?url").then(m => m.default),
    ],
    "OO": [
      () => import("@/assets/imgs/cabins/MSC_OP/OO/1.jpg?url").then(m => m.default),
    ],
    "IM2": [
      () => import("@/assets/imgs/cabins/MSC_OP/IM2/1.jpg?url").then(m => m.default),
    ],
    "OM2": [
      () => import("@/assets/imgs/cabins/MSC_OP/OM2/1.jpg?url").then(m => m.default),
    ],
    "SR1": [
      () => import("@/assets/imgs/cabins/MSC_OP/SR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_OP/SR1/ox_suite_02.jpg.jpg?url").then(m => m.default),
    ],
    "IM1": [
      () => import("@/assets/imgs/cabins/MSC_OP/IM1/1.jpg?url").then(m => m.default),
    ],
    "OM1": [
      () => import("@/assets/imgs/cabins/MSC_OP/OM1/1.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_OP/IB/1.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_OP/OB/1.jpg?url").then(m => m.default),
    ],
    "M1": [
      () => import("@/assets/imgs/cabins/MSC_OP/M1/1.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_OP/BB/1.jpg?url").then(m => m.default),
    ],
    "BM1": [
      () => import("@/assets/imgs/cabins/MSC_OP/BM1/1.jpg?url").then(m => m.default),
    ],
  },
  "MSC_OR": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_OR/IR1/1.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_OR/BA/1.jpg?url").then(m => m.default),
    ],
    "OO": [
      () => import("@/assets/imgs/cabins/MSC_OR/OO/1.jpg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_OR/BR2/1.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_OR/IR2/1.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_OR/IB/1.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_OR/OB/1.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_OR/SL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_OR/SL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_OR/SL1/3.jpg?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_OR/BR1/1.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_OR/BP/1.jpg?url").then(m => m.default),
    ],
    "BL1": [
      () => import("@/assets/imgs/cabins/MSC_OR/BL1/1.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_OR/BB/1.jpg?url").then(m => m.default),
    ],
    "OR2": [
      () => import("@/assets/imgs/cabins/MSC_OR/OR2/1.jpg?url").then(m => m.default),
    ],
    "BL2": [
      () => import("@/assets/imgs/cabins/MSC_OR/BL2/1.jpg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_OR/OR1/1.jpg?url").then(m => m.default),
    ],
  },
  "DI": {
    "EP": [
      () => import("@/assets/imgs/cabins/DI/EP/EP1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/EP/EP2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/EP/EP3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/EP/EP4.jpg?url").then(m => m.default),
    ],
    "I3": [
      () => import("@/assets/imgs/cabins/DI/I3/I1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/I3/I2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/I3/I3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/I3/I4.jpg?url").then(m => m.default),
    ],
    "S": [
      () => import("@/assets/imgs/cabins/DI/S/S1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/S/S2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/S/S3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/S/S4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/S/S5.jpg?url").then(m => m.default),
    ],
    "B2": [
      () => import("@/assets/imgs/cabins/DI/B2/B1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B2/B2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B2/B3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B2/B4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B2/B5.jpg?url").then(m => m.default),
    ],
    "B3": [
      () => import("@/assets/imgs/cabins/DI/B3/B1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B3/B2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B3/B3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B3/B4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B3/B5.jpg?url").then(m => m.default),
    ],
    "IV": [
      () => import("@/assets/imgs/cabins/DI/IV/IV1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/IV/IV2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/IV/IV3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/IV/IV4.jpg?url").then(m => m.default),
    ],
    "E1": [
      () => import("@/assets/imgs/cabins/DI/E1/E1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/E1/E2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/E1/E3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/E1/E4.jpg?url").then(m => m.default),
    ],
    "I4": [
      () => import("@/assets/imgs/cabins/DI/I4/I1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/I4/I2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/I4/I3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/I4/I4.jpg?url").then(m => m.default),
    ],
    "BC": [
      () => import("@/assets/imgs/cabins/DI/BC/BC1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/BC/BC2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/BC/BC3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/BC/BC4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/BC/BC5.jpg?url").then(m => m.default),
    ],
    "MS": [
      () => import("@/assets/imgs/cabins/DI/MS/MS1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/MS/MS2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/MS/MS3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/MS/MS4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/MS/MS5.jpg?url").then(m => m.default),
    ],
    "I1": [
      () => import("@/assets/imgs/cabins/DI/I1/I1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/I1/I2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/I1/I3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/I1/I4.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/DI/BP/BP1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/BP/BP2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/BP/BP3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/BP/BP4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/BP/BP5.jpg?url").then(m => m.default),
    ],
    "B1": [
      () => import("@/assets/imgs/cabins/DI/B1/B1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B1/B2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B1/B3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B1/B4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B1/B5.jpg?url").then(m => m.default),
    ],
    "EC": [
      () => import("@/assets/imgs/cabins/DI/EC/EC1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/EC/EC2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/EC/EC3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/EC/EC4.jpg?url").then(m => m.default),
    ],
    "IP": [
      () => import("@/assets/imgs/cabins/DI/IP/IP1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/IP/IP2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/IP/IP3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/IP/IP4.jpg?url").then(m => m.default),
    ],
    "EV": [
      () => import("@/assets/imgs/cabins/DI/EV/EV1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/EV/EV2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/EV/EV3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/EV/EV4.jpg?url").then(m => m.default),
    ],
    "BV": [
      () => import("@/assets/imgs/cabins/DI/BV/BV1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/BV/BV2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/BV/BV3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/BV/BV4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/BV/BV5.jpg?url").then(m => m.default),
    ],
    "I2": [
      () => import("@/assets/imgs/cabins/DI/I2/I1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/I2/I2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/I2/I3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/I2/I4.jpg?url").then(m => m.default),
    ],
    "IC": [
      () => import("@/assets/imgs/cabins/DI/IC/IC1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/IC/IC2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/IC/IC3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/IC/IC4.jpg?url").then(m => m.default),
    ],
    "B4": [
      () => import("@/assets/imgs/cabins/DI/B4/B1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B4/B2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B4/B3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B4/B4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/B4/B5.jpg?url").then(m => m.default),
    ],
    "GS": [
      () => import("@/assets/imgs/cabins/DI/GS/GS1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/GS/GS2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/GS/GS3.jpg?url").then(m => m.default),
    ],
    "E2": [
      () => import("@/assets/imgs/cabins/DI/E2/E1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/E2/E2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/E2/E3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DI/E2/E4.jpg?url").then(m => m.default),
    ],
  },
  "MSC_PO": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_PO/IR1/1.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_PO/BA/1.jpg?url").then(m => m.default),
    ],
    "OO": [
      () => import("@/assets/imgs/cabins/MSC_PO/OO/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PO/OO/2.jpg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_PO/BR2/1.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_PO/IR2/1.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_PO/IB/1.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_PO/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PO/OB/2.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_PO/SL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PO/SL1/2.jpg?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_PO/BR1/1.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_PO/BP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PO/BP/Suite.jpg?url").then(m => m.default),
    ],
    "BL1": [
      () => import("@/assets/imgs/cabins/MSC_PO/BL1/1.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_PO/BB/1.jpg?url").then(m => m.default),
    ],
    "OR2": [
      () => import("@/assets/imgs/cabins/MSC_PO/OR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PO/OR2/2.jpg?url").then(m => m.default),
    ],
    "BL2": [
      () => import("@/assets/imgs/cabins/MSC_PO/BL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PO/BL2/2.jpg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_PO/OR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PO/OR1/2.jpg?url").then(m => m.default),
    ],
  },
  "MSC_SI": {
    "OL1": [
      () => import("@/assets/imgs/cabins/MSC_SI/OL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SI/OL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SI/OL1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SI/OL1/4.jpg?url").then(m => m.default),
    ],
    "OO": [
      () => import("@/assets/imgs/cabins/MSC_SI/OO/1.jpg?url").then(m => m.default),
    ],
    "IM2": [
      () => import("@/assets/imgs/cabins/MSC_SI/IM2/1.jpg?url").then(m => m.default),
    ],
    "OM2": [
      () => import("@/assets/imgs/cabins/MSC_SI/OM2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SI/OM2/2.jpg?url").then(m => m.default),
    ],
    "SR1": [
      () => import("@/assets/imgs/cabins/MSC_SI/SR1/1.jpg?url").then(m => m.default),
    ],
    "IM1": [
      () => import("@/assets/imgs/cabins/MSC_SI/IM1/1.jpg?url").then(m => m.default),
    ],
    "SR2": [
      () => import("@/assets/imgs/cabins/MSC_SI/SR2/1.jpg?url").then(m => m.default),
    ],
    "OM1": [
      () => import("@/assets/imgs/cabins/MSC_SI/OM1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SI/OM1/2.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_SI/IB/1.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_SI/OB/1.jpg?url").then(m => m.default),
    ],
    "M1": [
      () => import("@/assets/imgs/cabins/MSC_SI/M1/1.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_SI/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SI/BB/2.jpg?url").then(m => m.default),
    ],
    "BM1": [
      () => import("@/assets/imgs/cabins/MSC_SI/BM1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SI/BM1/2.jpg?url").then(m => m.default),
    ],
  },
  "FI": {
    "EP": [
      () => import("@/assets/imgs/cabins/FI/EP/EP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/EP/EP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/EP/EP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/EP/EP4.jpeg?url").then(m => m.default),
    ],
    "I3": [
      () => import("@/assets/imgs/cabins/FI/I3/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I3/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I3/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I3/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I3/I5.jpeg?url").then(m => m.default),
    ],
    "S": [
      () => import("@/assets/imgs/cabins/FI/S/S1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/S/S2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/S/S3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/S/S4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/S/S5.jpeg?url").then(m => m.default),
    ],
    "B2": [
      () => import("@/assets/imgs/cabins/FI/B2/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B2/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B2/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B2/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B2/B5.jpeg?url").then(m => m.default),
    ],
    "B3": [
      () => import("@/assets/imgs/cabins/FI/B3/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B3/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B3/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B3/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B3/B5.jpeg?url").then(m => m.default),
    ],
    "IV": [
      () => import("@/assets/imgs/cabins/FI/IV/IV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/IV/IV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/IV/IV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/IV/IV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/IV/IV5.jpeg?url").then(m => m.default),
    ],
    "E1": [
      () => import("@/assets/imgs/cabins/FI/E1/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/E1/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/E1/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/E1/E4.jpeg?url").then(m => m.default),
    ],
    "I4": [
      () => import("@/assets/imgs/cabins/FI/I4/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I4/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I4/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I4/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I4/I5.jpeg?url").then(m => m.default),
    ],
    "BC": [
      () => import("@/assets/imgs/cabins/FI/BC/BC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/BC/BC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/BC/BC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/BC/BC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/BC/BC5.jpeg?url").then(m => m.default),
    ],
    "MS": [
      () => import("@/assets/imgs/cabins/FI/MS/MS1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/MS/MS2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/MS/MS3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/MS/MS4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/MS/MS5.jpeg?url").then(m => m.default),
    ],
    "I1": [
      () => import("@/assets/imgs/cabins/FI/I1/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I1/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I1/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I1/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I1/I5.jpeg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/FI/BP/BP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/BP/BP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/BP/BP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/BP/BP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/BP/BP5.jpeg?url").then(m => m.default),
    ],
    "B1": [
      () => import("@/assets/imgs/cabins/FI/B1/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B1/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B1/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B1/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B1/B5.jpeg?url").then(m => m.default),
    ],
    "EC": [
      () => import("@/assets/imgs/cabins/FI/EC/EC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/EC/EC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/EC/EC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/EC/EC4.jpeg?url").then(m => m.default),
    ],
    "IP": [
      () => import("@/assets/imgs/cabins/FI/IP/IP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/IP/IP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/IP/IP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/IP/IP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/IP/IP5.jpeg?url").then(m => m.default),
    ],
    "EV": [
      () => import("@/assets/imgs/cabins/FI/EV/EV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/EV/EV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/EV/EV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/EV/EV4.jpeg?url").then(m => m.default),
    ],
    "BV": [
      () => import("@/assets/imgs/cabins/FI/BV/BV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/BV/BV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/BV/BV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/BV/BV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/BV/BV5.jpeg?url").then(m => m.default),
    ],
    "I2": [
      () => import("@/assets/imgs/cabins/FI/I2/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I2/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I2/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I2/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/I2/I5.jpeg?url").then(m => m.default),
    ],
    "IC": [
      () => import("@/assets/imgs/cabins/FI/IC/IC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/IC/IC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/IC/IC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/IC/IC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/IC/IC5.jpeg?url").then(m => m.default),
    ],
    "B4": [
      () => import("@/assets/imgs/cabins/FI/B4/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B4/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B4/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B4/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/B4/B5.jpeg?url").then(m => m.default),
    ],
    "GS": [
      () => import("@/assets/imgs/cabins/FI/GS/S1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/GS/S2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/GS/S3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/GS/S4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/GS/S5.jpeg?url").then(m => m.default),
    ],
    "E2": [
      () => import("@/assets/imgs/cabins/FI/E2/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/E2/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/E2/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FI/E2/E4.jpeg?url").then(m => m.default),
    ],
  },
  "MSC_ER": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_ER/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/IR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/IR1/3.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_ER/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BA/4.jpg?url").then(m => m.default),
    ],
    "OO": [
      () => import("@/assets/imgs/cabins/MSC_ER/OO/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OO/2.jpg?url").then(m => m.default),
    ],
    "OM2": [
      () => import("@/assets/imgs/cabins/MSC_ER/OM2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OM2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OM2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OM2/4.jpg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_ER/YCT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YCT/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YCT/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YCT/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YCT/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YCT/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YCT/7.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YCT/8.jpg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_ER/BR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BR2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BR2/4.jpg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_ER/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YC1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YC1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YC1/4.jpg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_ER/YC3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YC3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YC3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YC3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YC3/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YC3/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YC3/7.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YC3/8.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_ER/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/IR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/IR2/3.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_ER/IB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/IB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/IB/3.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_ER/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OB/4.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_ER/SL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/SL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/SL1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/SL1/sl1_premium_suite_aurea_expandible_desktop_700x433_square.jpg?url").then(m => m.default),
    ],
    "BR3": [
      () => import("@/assets/imgs/cabins/MSC_ER/BR3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BR3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BR3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BR3/4.jpg?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_ER/BR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BR1/4.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_ER/BP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BP/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BP/4.jpg?url").then(m => m.default),
    ],
    "IS": [
      () => import("@/assets/imgs/cabins/MSC_ER/IS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/IS/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/IS/3.jpg?url").then(m => m.default),
    ],
    "SLJ": [
      () => import("@/assets/imgs/cabins/MSC_ER/SLJ/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/SLJ/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/SLJ/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/SLJ/slj_premium_suite_aurea_with_terrace_and_whirlpool_expandible_dextop_700x433_square.jpg?url").then(m => m.default),
    ],
    "BS": [
      () => import("@/assets/imgs/cabins/MSC_ER/BS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BS/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BS/3.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_ER/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/BB/4.jpg?url").then(m => m.default),
    ],
    "SXJ": [
      () => import("@/assets/imgs/cabins/MSC_ER/SXJ/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/SXJ/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/SXJ/SXJ.jpg?url").then(m => m.default),
    ],
    "YJD": [
      () => import("@/assets/imgs/cabins/MSC_ER/YJD/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YJD/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YJD/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YJD/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YJD/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YJD/6.jpg?url").then(m => m.default),
    ],
    "OL2": [
      () => import("@/assets/imgs/cabins/MSC_ER/OL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OL2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OL2/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OL2/5.jpg?url").then(m => m.default),
    ],
    "YIN": [
      () => import("@/assets/imgs/cabins/MSC_ER/YIN/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YIN/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YIN/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/YIN/4.jpg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_ER/OR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_ER/OR1/4.jpg?url").then(m => m.default),
    ],
  },
  "MSC_DI": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_DI/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/IR1/2.jpg?url").then(m => m.default),
    ],
    "OL1": [
      () => import("@/assets/imgs/cabins/MSC_DI/OL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/OL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/OL1/3.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_DI/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BA/4.jpg?url").then(m => m.default),
    ],
    "OM2": [
      () => import("@/assets/imgs/cabins/MSC_DI/OM2/1.jpg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_DI/YCT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/YCT/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/YCT/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/YCT/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/YCT/5.jpg?url").then(m => m.default),
    ],
    "SX": [
      () => import("@/assets/imgs/cabins/MSC_DI/SX/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/SX/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/SX/3.jpg?url").then(m => m.default),
    ],
    "YCP": [
      () => import("@/assets/imgs/cabins/MSC_DI/YCP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/YCP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/YCP/3.jpg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_DI/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/YC1/2.jpg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_DI/YC3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/YC3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/YC3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/YC3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/YC3/5.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_DI/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/IR2/2.jpg?url").then(m => m.default),
    ],
    "BL3": [
      () => import("@/assets/imgs/cabins/MSC_DI/BL3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BL3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BL3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BL3/4.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_DI/IB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/IB/2.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_DI/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/OB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/OB/3.jpg?url").then(m => m.default),
    ],
    "SRS": [
      () => import("@/assets/imgs/cabins/MSC_DI/SRS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/SRS/2.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_DI/SL1/1.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_DI/BP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BP/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BP/4.jpg?url").then(m => m.default),
    ],
    "YC2": [
      () => import("@/assets/imgs/cabins/MSC_DI/YC2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/YC2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/YC2/3.jpg?url").then(m => m.default),
    ],
    "OL3": [
      () => import("@/assets/imgs/cabins/MSC_DI/OL3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/OL3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/OL3/3.jpg?url").then(m => m.default),
    ],
    "BL1": [
      () => import("@/assets/imgs/cabins/MSC_DI/BL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BL1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BL1/4.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_DI/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BB/4.jpg?url").then(m => m.default),
    ],
    "SLS": [
      () => import("@/assets/imgs/cabins/MSC_DI/SLS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/SLS/2.jpg?url").then(m => m.default),
    ],
    "OR2": [
      () => import("@/assets/imgs/cabins/MSC_DI/OR2/1.jpg?url").then(m => m.default),
    ],
    "OL2": [
      () => import("@/assets/imgs/cabins/MSC_DI/OL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/OL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/OL2/3.jpg?url").then(m => m.default),
    ],
    "BL2": [
      () => import("@/assets/imgs/cabins/MSC_DI/BL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BL2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_DI/BL2/4.jpg?url").then(m => m.default),
    ],
  },
  "FS": {
    "EP": [
      () => import("@/assets/imgs/cabins/FS/EP/EP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/EP/EP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/EP/EP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/EP/EP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/EP/EP5.jpeg?url").then(m => m.default),
    ],
    "I3": [
      () => import("@/assets/imgs/cabins/FS/I3/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/I3/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/I3/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/I3/I4.jpeg?url").then(m => m.default),
    ],
    "S": [
      () => import("@/assets/imgs/cabins/FS/S/S1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/S/S2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/S/S3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/S/S4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/S/S5.jpeg?url").then(m => m.default),
    ],
    "B2": [
      () => import("@/assets/imgs/cabins/FS/B2/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/B2/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/B2/B3.jpeg?url").then(m => m.default),
    ],
    "B3": [
      () => import("@/assets/imgs/cabins/FS/B3/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/B3/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/B3/B3.jpeg?url").then(m => m.default),
    ],
    "IV": [
      () => import("@/assets/imgs/cabins/FS/IV/IV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/IV/IV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/IV/IV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/IV/IV4.jpeg?url").then(m => m.default),
    ],
    "E1": [
      () => import("@/assets/imgs/cabins/FS/E1/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/E1/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/E1/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/E1/E4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/E1/E5.jpeg?url").then(m => m.default),
    ],
    "I4": [
      () => import("@/assets/imgs/cabins/FS/I4/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/I4/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/I4/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/I4/I4.jpeg?url").then(m => m.default),
    ],
    "BC": [
      () => import("@/assets/imgs/cabins/FS/BC/BC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/BC/BC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/BC/BC3.jpeg?url").then(m => m.default),
    ],
    "MS": [
      () => import("@/assets/imgs/cabins/FS/MS/MS1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/MS/MS2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/MS/MS3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/MS/MS4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/MS/MS5.jpeg?url").then(m => m.default),
    ],
    "I1": [
      () => import("@/assets/imgs/cabins/FS/I1/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/I1/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/I1/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/I1/I4.jpeg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/FS/BP/BP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/BP/BP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/BP/BP3.jpeg?url").then(m => m.default),
    ],
    "B1": [
      () => import("@/assets/imgs/cabins/FS/B1/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/B1/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/B1/B3.jpeg?url").then(m => m.default),
    ],
    "EC": [
      () => import("@/assets/imgs/cabins/FS/EC/EC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/EC/EC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/EC/EC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/EC/EC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/EC/EC5.jpeg?url").then(m => m.default),
    ],
    "IP": [
      () => import("@/assets/imgs/cabins/FS/IP/IP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/IP/IP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/IP/IP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/IP/IP4.jpeg?url").then(m => m.default),
    ],
    "EV": [
      () => import("@/assets/imgs/cabins/FS/EV/EV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/EV/EV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/EV/EV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/EV/EV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/EV/EV5.jpeg?url").then(m => m.default),
    ],
    "BV": [
      () => import("@/assets/imgs/cabins/FS/BV/BV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/BV/BV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/BV/BV3.jpeg?url").then(m => m.default),
    ],
    "I2": [
      () => import("@/assets/imgs/cabins/FS/I2/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/I2/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/I2/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/I2/I4.jpeg?url").then(m => m.default),
    ],
    "IC": [
      () => import("@/assets/imgs/cabins/FS/IC/IC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/IC/IC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/IC/IC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/IC/IC4.jpeg?url").then(m => m.default),
    ],
    "B4": [
      () => import("@/assets/imgs/cabins/FS/B4/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/B4/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/B4/B3.jpeg?url").then(m => m.default),
    ],
    "GS": [
      () => import("@/assets/imgs/cabins/FS/GS/GS1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/GS/GS2.JPG?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/GS/GS3.jpg?url").then(m => m.default),
    ],
    "E2": [
      () => import("@/assets/imgs/cabins/FS/E2/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/E2/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/E2/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/E2/E4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FS/E2/E5.jpeg?url").then(m => m.default),
    ],
  },
  "MSC_SP": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_SP/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/IR1/2.jpg?url").then(m => m.default),
    ],
    "OL1": [
      () => import("@/assets/imgs/cabins/MSC_SP/OL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/OL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/OL1/3.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_SP/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BA/4.jpg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_SP/YCT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/YCT/2.jpg.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/YCT/3.jpg?url").then(m => m.default),
    ],
    "SX": [
      () => import("@/assets/imgs/cabins/MSC_SP/SX/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/SX/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/SX/3.jpg?url").then(m => m.default),
    ],
    "YCP": [
      () => import("@/assets/imgs/cabins/MSC_SP/YCP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/YCP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/YCP/3.jpg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_SP/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/YC1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/YC1/YachtClub_deluxe_suite.jpg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_SP/YC3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/YC3/2.jpg.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/YC3/3.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_SP/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/IR2/2.jpg?url").then(m => m.default),
    ],
    "BL3": [
      () => import("@/assets/imgs/cabins/MSC_SP/BL3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BL3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BL3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BL3/4.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_SP/IB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/IB/2.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_SP/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/OB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/OB/3.jpg?url").then(m => m.default),
    ],
    "SRS": [
      () => import("@/assets/imgs/cabins/MSC_SP/SRS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/SRS/2.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_SP/SL1/1.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_SP/BP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BP/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BP/4.jpg?url").then(m => m.default),
    ],
    "YC2": [
      () => import("@/assets/imgs/cabins/MSC_SP/YC2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/YC2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/YC2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/YC2/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/YC2/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/YC2/6.jpg?url").then(m => m.default),
    ],
    "OL3": [
      () => import("@/assets/imgs/cabins/MSC_SP/OL3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/OL3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/OL3/3.jpg?url").then(m => m.default),
    ],
    "OL": [
      () => import("@/assets/imgs/cabins/MSC_SP/OL/1.jpg?url").then(m => m.default),
    ],
    "BL1": [
      () => import("@/assets/imgs/cabins/MSC_SP/BL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BL1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BL1/4.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_SP/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BB/4.jpg?url").then(m => m.default),
    ],
    "SLS": [
      () => import("@/assets/imgs/cabins/MSC_SP/SLS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/SLS/2.jpg?url").then(m => m.default),
    ],
    "OL2": [
      () => import("@/assets/imgs/cabins/MSC_SP/OL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/OL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/OL2/3.jpg?url").then(m => m.default),
    ],
    "BL2": [
      () => import("@/assets/imgs/cabins/MSC_SP/BL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BL2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SP/BL2/4.jpg?url").then(m => m.default),
    ],
  },
  "MSC_EU": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_EU/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/IR1/2.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_EU/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BA/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BA/5.jpg?url").then(m => m.default),
    ],
    "YCD": [
      () => import("@/assets/imgs/cabins/MSC_EU/YCD/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YCD/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YCD/msc-yacht-club-duplex-suite-with-whirlpool-bath_yjd_700x433.jpg.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YCD/yjd-duplex-suite-6.jpg?url").then(m => m.default),
    ],
    "SXT": [
      () => import("@/assets/imgs/cabins/MSC_EU/SXT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/SXT/sxt-grand-suite-aurea-with-terrace-2.jpg?url").then(m => m.default),
    ],
    "OS": [
      () => import("@/assets/imgs/cabins/MSC_EU/OS/1.jpg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_EU/YCT/msc-yacht-club-royal-suite-with-whirlpool-bath_yc3_700x433.jpg.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YCT/yc3-royal-suite.jpg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_EU/BR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BR2/2.jpg?url").then(m => m.default),
    ],
    "SX": [
      () => import("@/assets/imgs/cabins/MSC_EU/SX/1.jpg?url").then(m => m.default),
    ],
    "PR2": [
      () => import("@/assets/imgs/cabins/MSC_EU/PR2/1 2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/PR2/1.jpg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_EU/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YC1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YC1/3.jpg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_EU/YC3/msc-yacht-club-royal-suite-with-whirlpool-bath_yc3_700x433.jpg.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YC3/yc3-royal-suite.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_EU/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/IR2/2.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_EU/IB/1 2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/IB/1.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_EU/OB/1.jpg?url").then(m => m.default),
    ],
    "PR1": [
      () => import("@/assets/imgs/cabins/MSC_EU/PR1/1 2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/PR1/1.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_EU/SL1/1.jpg?url").then(m => m.default),
    ],
    "BR3": [
      () => import("@/assets/imgs/cabins/MSC_EU/BR3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BR3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BR3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BR3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BR3/5.jpg?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_EU/BR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BR1/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BR1/5.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_EU/BP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BP/2.jpg?url").then(m => m.default),
    ],
    "SRP": [
      () => import("@/assets/imgs/cabins/MSC_EU/SRP/srp-deluxe-suite-aurea-promenade-and-ocean-view.jpg?url").then(m => m.default),
    ],
    "VLA": [
      () => import("@/assets/imgs/cabins/MSC_EU/VLA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/VLA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/VLA/3.jpg?url").then(m => m.default),
    ],
    "IS": [
      () => import("@/assets/imgs/cabins/MSC_EU/IS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/IS/2.jpg?url").then(m => m.default),
    ],
    "PR3": [
      () => import("@/assets/imgs/cabins/MSC_EU/PR3/1.jpg?url").then(m => m.default),
    ],
    "SM": [
      () => import("@/assets/imgs/cabins/MSC_EU/SM/1.jpg?url").then(m => m.default),
    ],
    "PV": [
      () => import("@/assets/imgs/cabins/MSC_EU/PV/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/PV/2.jpg?url").then(m => m.default),
    ],
    "BGA": [
      () => import("@/assets/imgs/cabins/MSC_EU/BGA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BGA/2.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_EU/BB/1 2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BB/1 3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BB/2.jpg?url").then(m => m.default),
    ],
    "OR2": [
      () => import("@/assets/imgs/cabins/MSC_EU/OR2/1.jpg?url").then(m => m.default),
    ],
    "SXJ": [
      () => import("@/assets/imgs/cabins/MSC_EU/SXJ/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/SXJ/sxt-grand-suite-aurea-with-terrace-2.jpg?url").then(m => m.default),
    ],
    "YC4": [
      () => import("@/assets/imgs/cabins/MSC_EU/YC4/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YC4/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YC4/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YC4/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YC4/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YC4/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YC4/7.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YC4/8.jpg?url").then(m => m.default),
    ],
    "YJD": [
      () => import("@/assets/imgs/cabins/MSC_EU/YJD/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YJD/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YJD/msc-yacht-club-duplex-suite-with-whirlpool-bath_yjd_700x433.jpg.jpg?url").then(m => m.default),
    ],
    "VL1": [
      () => import("@/assets/imgs/cabins/MSC_EU/VL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/VL1/2 2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/VL1/3.jpg?url").then(m => m.default),
    ],
    "BR4": [
      () => import("@/assets/imgs/cabins/MSC_EU/BR4/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BR4/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BR4/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BR4/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/BR4/5.jpg?url").then(m => m.default),
    ],
    "YIN": [
      () => import("@/assets/imgs/cabins/MSC_EU/YIN/1 (kopie).jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/YIN/1.jpg?url").then(m => m.default),
    ],
    "SLP": [
      () => import("@/assets/imgs/cabins/MSC_EU/SLP/slp-premium-suite-aurea-with-promenade-and-ocean-view.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_EU/SLP/srp-deluxe-suite-aurea-promenade-and-ocean-view.jpg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_EU/OR1/1.jpg?url").then(m => m.default),
    ],
  },
  "MSC_SH": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_SH/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/IR1/I_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/IR1/I_2.jpeg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_SH/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BA/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BA/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BA/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BA/B_2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BA/sh_junior_auite_aurea_sm_700x433.jpg?url").then(m => m.default),
    ],
    "SD": [
      () => import("@/assets/imgs/cabins/MSC_SH/SD/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SD/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SD/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SD/SD1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SD/SD2.jpeg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_SH/YCT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YCT/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YCT/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YCT/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YCT/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YCT/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YCT/YC3_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YCT/YC3_2.jpeg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_SH/BR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR2/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR2/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR2/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR2/B_2.jpeg?url").then(m => m.default),
    ],
    "SX": [
      () => import("@/assets/imgs/cabins/MSC_SH/SX/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SX/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SX/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SX/SX_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SX/SX_2.jpeg?url").then(m => m.default),
    ],
    "YCP": [
      () => import("@/assets/imgs/cabins/MSC_SH/YCP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YCP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YCP/3.jpg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_SH/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC1/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC1/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC1/YC1_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC1/YC1_2.jpeg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_SH/YC3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC3/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC3/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC3/YC3_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC3/YC3_2.jpeg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_SH/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/IR2/I_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/IR2/I_2.jpeg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_SH/IB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/IB/I_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/IB/I_2.jpeg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_SH/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/OB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/OB/O_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/OB/O_2.jpeg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_SH/SL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SL1/SL1.png?url").then(m => m.default),
    ],
    "SLT": [
      () => import("@/assets/imgs/cabins/MSC_SH/SLT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SLT/SLT.png?url").then(m => m.default),
    ],
    "BR3": [
      () => import("@/assets/imgs/cabins/MSC_SH/BR3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR3/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR3/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR3/B_2.jpeg?url").then(m => m.default),
    ],
    "IL1": [
      () => import("@/assets/imgs/cabins/MSC_SH/IL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/IL1/IL1.png?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_SH/BR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR1/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR1/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR1/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR1/B_2.jpeg?url").then(m => m.default),
    ],
    "SLW": [
      () => import("@/assets/imgs/cabins/MSC_SH/SLW/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SLW/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SLW/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SLW/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SLW/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SLW/SLW1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SLW/SLW2.jpeg?url").then(m => m.default),
    ],
    "SM": [
      () => import("@/assets/imgs/cabins/MSC_SH/SM/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SM/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SM/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SM/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SM/SM1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/SM/SM2.jpeg?url").then(m => m.default),
    ],
    "BGA": [
      () => import("@/assets/imgs/cabins/MSC_SH/BGA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BGA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BGA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BGA/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BGA/BGA_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BGA/BGA_2.jpeg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_SH/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BB/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BB/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BB/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BB/B_2.jpeg?url").then(m => m.default),
    ],
    "YC4": [
      () => import("@/assets/imgs/cabins/MSC_SH/YC4/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC4/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC4/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC4/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC4/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC4/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC4/7.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC4/8.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YC4/YC4.jpeg?url").then(m => m.default),
    ],
    "BR4": [
      () => import("@/assets/imgs/cabins/MSC_SH/BR4/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR4/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR4/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR4/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR4/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR4/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/BR4/B_2.jpeg?url").then(m => m.default),
    ],
    "YIN": [
      () => import("@/assets/imgs/cabins/MSC_SH/YIN/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YIN/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YIN/YIN_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/YIN/YIN_2.jpeg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_SH/OR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/OR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/OR1/O_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SH/OR1/O_2.jpeg?url").then(m => m.default),
    ],
  },
  "MSC_PR": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_PR/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/IR1/2.jpg?url").then(m => m.default),
    ],
    "OL1": [
      () => import("@/assets/imgs/cabins/MSC_PR/OL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/OL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/OL1/3.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_PR/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BA/4.jpg?url").then(m => m.default),
    ],
    "IM2": [
      () => import("@/assets/imgs/cabins/MSC_PR/IM2/1.jpg?url").then(m => m.default),
    ],
    "OM2": [
      () => import("@/assets/imgs/cabins/MSC_PR/OM2/1.jpg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_PR/YCT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/YCT/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/YCT/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/YCT/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/YCT/5.jpg?url").then(m => m.default),
    ],
    "IM1": [
      () => import("@/assets/imgs/cabins/MSC_PR/IM1/1.jpg?url").then(m => m.default),
    ],
    "SX": [
      () => import("@/assets/imgs/cabins/MSC_PR/SX/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/SX/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/SX/3.jpg?url").then(m => m.default),
    ],
    "YCP": [
      () => import("@/assets/imgs/cabins/MSC_PR/YCP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/YCP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/YCP/3.jpg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_PR/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/YC1/2.jpg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_PR/YC3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/YC3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/YC3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/YC3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/YC3/5.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_PR/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/IR2/2.jpg?url").then(m => m.default),
    ],
    "BL3": [
      () => import("@/assets/imgs/cabins/MSC_PR/BL3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BL3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BL3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BL3/4.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_PR/IB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/IB/2.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_PR/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/OB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/OB/3.jpg?url").then(m => m.default),
    ],
    "SRS": [
      () => import("@/assets/imgs/cabins/MSC_PR/SRS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/SRS/2.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_PR/SL1/1.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_PR/BP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BP/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BP/4.jpg?url").then(m => m.default),
    ],
    "YC2": [
      () => import("@/assets/imgs/cabins/MSC_PR/YC2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/YC2/2.jpg?url").then(m => m.default),
    ],
    "BM2": [
      () => import("@/assets/imgs/cabins/MSC_PR/BM2/1.jpg?url").then(m => m.default),
    ],
    "OL3": [
      () => import("@/assets/imgs/cabins/MSC_PR/OL3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/OL3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/OL3/3.jpg?url").then(m => m.default),
    ],
    "BL1": [
      () => import("@/assets/imgs/cabins/MSC_PR/BL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BL1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BL1/4.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_PR/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BB/4.jpg?url").then(m => m.default),
    ],
    "BM1": [
      () => import("@/assets/imgs/cabins/MSC_PR/BM1/1.jpg?url").then(m => m.default),
    ],
    "SLS": [
      () => import("@/assets/imgs/cabins/MSC_PR/SLS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/SLS/2.jpg?url").then(m => m.default),
    ],
    "OR2": [
      () => import("@/assets/imgs/cabins/MSC_PR/OR2/1.jpg?url").then(m => m.default),
    ],
    "OL2": [
      () => import("@/assets/imgs/cabins/MSC_PR/OL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/OL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/OL2/3.jpg?url").then(m => m.default),
    ],
    "BL2": [
      () => import("@/assets/imgs/cabins/MSC_PR/BL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BL2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_PR/BL2/4.jpg?url").then(m => m.default),
    ],
  },
  "SM": {
    "EP": [
      () => import("@/assets/imgs/cabins/SM/EP/EP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/EP/EP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/EP/EP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/EP/EP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/EP/EP5.jpeg?url").then(m => m.default),
    ],
    "I3": [
      () => import("@/assets/imgs/cabins/SM/I3/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I3/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I3/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I3/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I3/I5.jpeg?url").then(m => m.default),
    ],
    "S": [
      () => import("@/assets/imgs/cabins/SM/S/S1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/S/S2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/S/S3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/S/S4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/S/S5.jpeg?url").then(m => m.default),
    ],
    "B2": [
      () => import("@/assets/imgs/cabins/SM/B2/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B2/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B2/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B2/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B2/B5.jpeg?url").then(m => m.default),
    ],
    "B3": [
      () => import("@/assets/imgs/cabins/SM/B3/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B3/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B3/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B3/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B3/B5.jpeg?url").then(m => m.default),
    ],
    "IV": [
      () => import("@/assets/imgs/cabins/SM/IV/IV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/IV/IV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/IV/IV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/IV/IV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/IV/IV5.jpeg?url").then(m => m.default),
    ],
    "E1": [
      () => import("@/assets/imgs/cabins/SM/E1/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/E1/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/E1/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/E1/E4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/E1/E5.jpeg?url").then(m => m.default),
    ],
    "I4": [
      () => import("@/assets/imgs/cabins/SM/I4/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I4/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I4/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I4/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I4/I5.jpeg?url").then(m => m.default),
    ],
    "BC": [
      () => import("@/assets/imgs/cabins/SM/BC/BC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/BC/BC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/BC/BC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/BC/BC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/BC/BC5.jpeg?url").then(m => m.default),
    ],
    "I1": [
      () => import("@/assets/imgs/cabins/SM/I1/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I1/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I1/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I1/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I1/I5.jpeg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/SM/BP/BP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/BP/BP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/BP/BP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/BP/BP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/BP/BP5.jpeg?url").then(m => m.default),
    ],
    "TP": [
      () => import("@/assets/imgs/cabins/SM/TP/TP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/TP/TP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/TP/TP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/TP/TP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/TP/TP5.jpeg?url").then(m => m.default),
    ],
    "B1": [
      () => import("@/assets/imgs/cabins/SM/B1/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B1/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B1/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B1/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B1/B5.jpeg?url").then(m => m.default),
    ],
    "EC": [
      () => import("@/assets/imgs/cabins/SM/EC/EC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/EC/EC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/EC/EC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/EC/EC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/EC/EC5.jpeg?url").then(m => m.default),
    ],
    "IP": [
      () => import("@/assets/imgs/cabins/SM/IP/IP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/IP/IP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/IP/IP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/IP/IP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/IP/IP5.jpeg?url").then(m => m.default),
    ],
    "TV": [
      () => import("@/assets/imgs/cabins/SM/TV/TV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/TV/TV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/TV/TV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/TV/TV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/TV/TV5.jpeg?url").then(m => m.default),
    ],
    "EV": [
      () => import("@/assets/imgs/cabins/SM/EV/EV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/EV/EV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/EV/EV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/EV/EV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/EV/EV5.jpeg?url").then(m => m.default),
    ],
    "T1": [
      () => import("@/assets/imgs/cabins/SM/T1/T1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/T1/T2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/T1/T3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/T1/T4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/T1/T5.jpeg?url").then(m => m.default),
    ],
    "BV": [
      () => import("@/assets/imgs/cabins/SM/BV/BV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/BV/BV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/BV/BV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/BV/BV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/BV/BV5.jpeg?url").then(m => m.default),
    ],
    "I2": [
      () => import("@/assets/imgs/cabins/SM/I2/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I2/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I2/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I2/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/I2/I5.jpeg?url").then(m => m.default),
    ],
    "IC": [
      () => import("@/assets/imgs/cabins/SM/IC/IC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/IC/IC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/IC/IC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/IC/IC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/IC/IC5.jpeg?url").then(m => m.default),
    ],
    "B4": [
      () => import("@/assets/imgs/cabins/SM/B4/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B4/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B4/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B4/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/B4/B5.jpeg?url").then(m => m.default),
    ],
    "GS": [
      () => import("@/assets/imgs/cabins/SM/GS/GS1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/GS/GS2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/GS/GS3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/GS/GS4.jpg?url").then(m => m.default),
    ],
    "E2": [
      () => import("@/assets/imgs/cabins/SM/E2/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/E2/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/E2/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/E2/E4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/E2/E5.jpeg?url").then(m => m.default),
    ],
    "T2": [
      () => import("@/assets/imgs/cabins/SM/T2/T1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/T2/T2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/T2/T3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/T2/T4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/T2/T5.jpeg?url").then(m => m.default),
    ],
    "TC": [
      () => import("@/assets/imgs/cabins/SM/TC/TC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/TC/TC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/TC/TC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/TC/TC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/SM/TC/TC5.jpeg?url").then(m => m.default),
    ],
  },
  "MSC_MR": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_MR/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/IR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/IR1/3.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_MR/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BA/4.jpg?url").then(m => m.default),
    ],
    "OO": [
      () => import("@/assets/imgs/cabins/MSC_MR/OO/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OO/2.jpg?url").then(m => m.default),
    ],
    "OM2": [
      () => import("@/assets/imgs/cabins/MSC_MR/OM2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OM2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OM2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OM2/4.jpg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_MR/YCT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/YCT/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/YCT/3.jpg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_MR/BR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BR2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BR2/4.jpg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_MR/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/YC1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/YC1/3.jpg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_MR/YC3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/YC3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/YC3/3.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_MR/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/IR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/IR2/3.jpg?url").then(m => m.default),
    ],
    "BL3": [
      () => import("@/assets/imgs/cabins/MSC_MR/BL3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BL3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BL3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BL3/4.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_MR/IB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/IB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/IB/3.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_MR/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OB/4.jpg?url").then(m => m.default),
    ],
    "BR3": [
      () => import("@/assets/imgs/cabins/MSC_MR/BR3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BR3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BR3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BR3/4.jpg?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_MR/BR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BR1/4.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_MR/BP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BP/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BP/4.jpg?url").then(m => m.default),
    ],
    "IS": [
      () => import("@/assets/imgs/cabins/MSC_MR/IS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/IS/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/IS/3.jpg?url").then(m => m.default),
    ],
    "BL1": [
      () => import("@/assets/imgs/cabins/MSC_MR/BL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BL1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BL1/4.jpg?url").then(m => m.default),
    ],
    "SLJ": [
      () => import("@/assets/imgs/cabins/MSC_MR/SLJ/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/SLJ/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/SLJ/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/SLJ/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/SLJ/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/SLJ/6.jpg?url").then(m => m.default),
    ],
    "BS": [
      () => import("@/assets/imgs/cabins/MSC_MR/BS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BS/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BS/3.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_MR/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BB/4.jpg?url").then(m => m.default),
    ],
    "SXJ": [
      () => import("@/assets/imgs/cabins/MSC_MR/SXJ/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/SXJ/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/SXJ/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/SXJ/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/SXJ/5.jpg?url").then(m => m.default),
    ],
    "YJD": [
      () => import("@/assets/imgs/cabins/MSC_MR/YJD/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/YJD/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/YJD/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/YJD/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/YJD/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/YJD/6.jpg?url").then(m => m.default),
    ],
    "OL2": [
      () => import("@/assets/imgs/cabins/MSC_MR/OL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OL2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OL2/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OL2/5.jpg?url").then(m => m.default),
    ],
    "YIN": [
      () => import("@/assets/imgs/cabins/MSC_MR/YIN/1.jpg?url").then(m => m.default),
    ],
    "BL2": [
      () => import("@/assets/imgs/cabins/MSC_MR/BL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BL2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/BL2/4.jpg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_MR/OR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MR/OR1/4.jpg?url").then(m => m.default),
    ],
  },
  "MSC_VI": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_VI/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/IR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/IR1/3.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_VI/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BA/4.jpg?url").then(m => m.default),
    ],
    "OO": [
      () => import("@/assets/imgs/cabins/MSC_VI/OO/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OO/2.jpg?url").then(m => m.default),
    ],
    "OM2": [
      () => import("@/assets/imgs/cabins/MSC_VI/OM2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OM2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OM2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OM2/4.jpg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_VI/YCT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YCT/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YCT/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YCT/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YCT/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YCT/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YCT/7.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YCT/8.jpg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_VI/BR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BR2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BR2/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BR2/Deluxe_balcony_BR2 (2).jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BR2/Deluxe_balcony_BR2 (3).jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BR2/Deluxe_balcony_BR2 (4).jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BR2/Deluxe_balcony_BR2 (5).jpg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_VI/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YC1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YC1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YC1/4.jpg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_VI/YC3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YC3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YC3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YC3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YC3/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YC3/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YC3/7.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YC3/8.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_VI/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/IR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/IR2/3.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_VI/IB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/IB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/IB/3.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_VI/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OB/4.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_VI/SL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/SL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/SL1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/SL1/sl1_premium_suite_aurea_expandible_desktop_700x433_square.jpg?url").then(m => m.default),
    ],
    "BR3": [
      () => import("@/assets/imgs/cabins/MSC_VI/BR3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BR3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BR3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BR3/4.jpg?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_VI/BR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BR1/4.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_VI/BP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BP/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BP/4.jpg?url").then(m => m.default),
    ],
    "IS": [
      () => import("@/assets/imgs/cabins/MSC_VI/IS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/IS/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/IS/3.jpg?url").then(m => m.default),
    ],
    "SLJ": [
      () => import("@/assets/imgs/cabins/MSC_VI/SLJ/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/SLJ/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/SLJ/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/SLJ/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/SLJ/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/SLJ/6.jpg?url").then(m => m.default),
    ],
    "BS": [
      () => import("@/assets/imgs/cabins/MSC_VI/BS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BS/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BS/3.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_VI/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/BB/4.jpg?url").then(m => m.default),
    ],
    "SXJ": [
      () => import("@/assets/imgs/cabins/MSC_VI/SXJ/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/SXJ/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/SXJ/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/SXJ/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/SXJ/5.jpg?url").then(m => m.default),
    ],
    "YJD": [
      () => import("@/assets/imgs/cabins/MSC_VI/YJD/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YJD/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YJD/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YJD/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YJD/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YJD/6.jpg?url").then(m => m.default),
    ],
    "OL2": [
      () => import("@/assets/imgs/cabins/MSC_VI/OL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OL2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OL2/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OL2/5.jpg?url").then(m => m.default),
    ],
    "YIN": [
      () => import("@/assets/imgs/cabins/MSC_VI/YIN/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YIN/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YIN/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/YIN/4.jpg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_VI/OR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_VI/OR1/4.jpg?url").then(m => m.default),
    ],
  },
  "MSC_LI": {
    "OL1": [
      () => import("@/assets/imgs/cabins/MSC_LI/OL1/1.jpg?url").then(m => m.default),
    ],
    "OO": [
      () => import("@/assets/imgs/cabins/MSC_LI/OO/1.jpg?url").then(m => m.default),
    ],
    "IM2": [
      () => import("@/assets/imgs/cabins/MSC_LI/IM2/1.jpg?url").then(m => m.default),
    ],
    "OM2": [
      () => import("@/assets/imgs/cabins/MSC_LI/OM2/1.jpg?url").then(m => m.default),
    ],
    "SR1": [
      () => import("@/assets/imgs/cabins/MSC_LI/SR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_LI/SR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_LI/SR1/ox_suite_02.jpg.jpg?url").then(m => m.default),
    ],
    "IM1": [
      () => import("@/assets/imgs/cabins/MSC_LI/IM1/1.jpg?url").then(m => m.default),
    ],
    "SR2": [
      () => import("@/assets/imgs/cabins/MSC_LI/SR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_LI/SR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_LI/SR2/ox_suite_02.jpg.jpg?url").then(m => m.default),
    ],
    "OM1": [
      () => import("@/assets/imgs/cabins/MSC_LI/OM1/1.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_LI/IB/1.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_LI/OB/1.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_LI/BB/1.jpg?url").then(m => m.default),
    ],
    "BM1": [
      () => import("@/assets/imgs/cabins/MSC_LI/BM1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_LI/BM1/2.jpg?url").then(m => m.default),
    ],
  },
  "FA": {
    "EP": [
      () => import("@/assets/imgs/cabins/FA/EP/EP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/EP/EP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/EP/EP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/EP/EP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/EP/EP5.jpeg?url").then(m => m.default),
    ],
    "I3": [
      () => import("@/assets/imgs/cabins/FA/I3/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/I3/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/I3/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/I3/I4.jpeg?url").then(m => m.default),
    ],
    "S": [
      () => import("@/assets/imgs/cabins/FA/S/S1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/S/S2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/S/S3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/S/S4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/S/S5.jpeg?url").then(m => m.default),
    ],
    "B2": [
      () => import("@/assets/imgs/cabins/FA/B2/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/B2/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/B2/B3.jpeg?url").then(m => m.default),
    ],
    "B3": [
      () => import("@/assets/imgs/cabins/FA/B3/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/B3/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/B3/B3.jpeg?url").then(m => m.default),
    ],
    "IV": [
      () => import("@/assets/imgs/cabins/FA/IV/IV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/IV/IV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/IV/IV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/IV/IV4.jpeg?url").then(m => m.default),
    ],
    "E1": [
      () => import("@/assets/imgs/cabins/FA/E1/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/E1/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/E1/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/E1/E4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/E1/E5.jpeg?url").then(m => m.default),
    ],
    "I4": [
      () => import("@/assets/imgs/cabins/FA/I4/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/I4/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/I4/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/I4/I4.jpeg?url").then(m => m.default),
    ],
    "BC": [
      () => import("@/assets/imgs/cabins/FA/BC/BC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/BC/BC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/BC/BC3.jpeg?url").then(m => m.default),
    ],
    "MS": [
      () => import("@/assets/imgs/cabins/FA/MS/MS1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/MS/MS2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/MS/MS3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/MS/MS4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/MS/MS5.jpeg?url").then(m => m.default),
    ],
    "I1": [
      () => import("@/assets/imgs/cabins/FA/I1/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/I1/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/I1/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/I1/I4.jpeg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/FA/BP/BP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/BP/BP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/BP/BP3.jpeg?url").then(m => m.default),
    ],
    "B1": [
      () => import("@/assets/imgs/cabins/FA/B1/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/B1/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/B1/B3.jpeg?url").then(m => m.default),
    ],
    "EC": [
      () => import("@/assets/imgs/cabins/FA/EC/EC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/EC/EC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/EC/EC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/EC/EC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/EC/EC5.jpeg?url").then(m => m.default),
    ],
    "IP": [
      () => import("@/assets/imgs/cabins/FA/IP/IP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/IP/IP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/IP/IP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/IP/IP4.jpeg?url").then(m => m.default),
    ],
    "EV": [
      () => import("@/assets/imgs/cabins/FA/EV/EV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/EV/EV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/EV/EV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/EV/EV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/EV/EV5.jpeg?url").then(m => m.default),
    ],
    "BV": [
      () => import("@/assets/imgs/cabins/FA/BV/BV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/BV/BV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/BV/BV3.jpeg?url").then(m => m.default),
    ],
    "I2": [
      () => import("@/assets/imgs/cabins/FA/I2/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/I2/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/I2/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/I2/I4.jpeg?url").then(m => m.default),
    ],
    "IC": [
      () => import("@/assets/imgs/cabins/FA/IC/IC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/IC/IC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/IC/IC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/IC/IC4.jpeg?url").then(m => m.default),
    ],
    "B4": [
      () => import("@/assets/imgs/cabins/FA/B4/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/B4/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/B4/B3.jpeg?url").then(m => m.default),
    ],
    "GS": [
      () => import("@/assets/imgs/cabins/FA/GS/GS1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/GS/GS2.JPG?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/GS/GS3.jpg?url").then(m => m.default),
    ],
    "E2": [
      () => import("@/assets/imgs/cabins/FA/E2/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/E2/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/E2/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/E2/E4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FA/E2/E5.jpeg?url").then(m => m.default),
    ],
  },
  "MSC_SE": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_SE/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/IR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/IR1/I_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/IR1/I_2.jpeg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_SE/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BA/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BA/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BA/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BA/B_2.jpeg?url").then(m => m.default),
    ],
    "SR1": [
      () => import("@/assets/imgs/cabins/MSC_SE/SR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SR1/SR1.png?url").then(m => m.default),
    ],
    "SD": [
      () => import("@/assets/imgs/cabins/MSC_SE/SD/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SD/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SD/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SD/SD1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SD/SD2.jpeg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_SE/YCT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YCT/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YCT/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YCT/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YCT/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YCT/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YCT/YC3_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YCT/YC3_2.jpeg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_SE/BR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR2/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR2/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR2/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR2/B_2.jpeg?url").then(m => m.default),
    ],
    "SX": [
      () => import("@/assets/imgs/cabins/MSC_SE/SX/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SX/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SX/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SX/SX_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SX/SX_2.jpeg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_SE/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YC1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YC1/YC1_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YC1/YC1_2.jpeg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_SE/YC3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YC3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YC3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YC3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YC3/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YC3/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YC3/YC3_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YC3/YC3_2.jpeg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_SE/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/IR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/IR2/I_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/IR2/I_2.jpeg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_SE/IB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/IB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/IB/I_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/IB/I_2.jpeg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_SE/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/OB/O_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/OB/O_2.jpeg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_SE/SL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SL1/SL1.png?url").then(m => m.default),
    ],
    "SLT": [
      () => import("@/assets/imgs/cabins/MSC_SE/SLT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SLT/SLT.png?url").then(m => m.default),
    ],
    "BR3": [
      () => import("@/assets/imgs/cabins/MSC_SE/BR3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR3/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR3/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR3/B_2.jpeg?url").then(m => m.default),
    ],
    "IL1": [
      () => import("@/assets/imgs/cabins/MSC_SE/IL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/IL1/IL1.png?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_SE/BR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR1/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR1/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR1/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR1/B_2.jpeg?url").then(m => m.default),
    ],
    "SLW": [
      () => import("@/assets/imgs/cabins/MSC_SE/SLW/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SLW/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SLW/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SLW/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SLW/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SLW/SLW1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SLW/SLW2.jpeg?url").then(m => m.default),
    ],
    "SM": [
      () => import("@/assets/imgs/cabins/MSC_SE/SM/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SM/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SM/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SM/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SM/SM1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/SM/SM2.jpeg?url").then(m => m.default),
    ],
    "BGA": [
      () => import("@/assets/imgs/cabins/MSC_SE/BGA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BGA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BGA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BGA/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BGA/BGA_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BGA/BGA_2.jpeg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_SE/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BB/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BB/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BB/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BB/B_2.jpeg?url").then(m => m.default),
    ],
    "BR4": [
      () => import("@/assets/imgs/cabins/MSC_SE/BR4/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR4/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR4/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR4/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR4/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR4/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/BR4/B_2.jpeg?url").then(m => m.default),
    ],
    "YIN": [
      () => import("@/assets/imgs/cabins/MSC_SE/YIN/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YIN/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YIN/YIN_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/YIN/YIN_2.jpeg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_SE/OR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/OR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/OR1/O_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SE/OR1/O_2.jpeg?url").then(m => m.default),
    ],
  },
  "VE": {
    "EP": [
      () => import("@/assets/imgs/cabins/VE/EP/EP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/EP/EP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/EP/EP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/EP/EP4.jpeg?url").then(m => m.default),
    ],
    "I3": [
      () => import("@/assets/imgs/cabins/VE/I3/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I3/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I3/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I3/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I3/I5.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I3/I6.jpeg?url").then(m => m.default),
    ],
    "S": [
      () => import("@/assets/imgs/cabins/VE/S/S1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/S/S2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/S/S3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/S/S4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/S/S5.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/S/S6.jpeg?url").then(m => m.default),
    ],
    "B2": [
      () => import("@/assets/imgs/cabins/VE/B2/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B2/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B2/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B2/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B2/B5.jpeg?url").then(m => m.default),
    ],
    "B3": [
      () => import("@/assets/imgs/cabins/VE/B3/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B3/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B3/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B3/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B3/B5.jpeg?url").then(m => m.default),
    ],
    "IV": [
      () => import("@/assets/imgs/cabins/VE/IV/IV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IV/IV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IV/IV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IV/IV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IV/IV5.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IV/IV6.jpeg?url").then(m => m.default),
    ],
    "E1": [
      () => import("@/assets/imgs/cabins/VE/E1/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/E1/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/E1/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/E1/E4.jpeg?url").then(m => m.default),
    ],
    "I4": [
      () => import("@/assets/imgs/cabins/VE/I4/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I4/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I4/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I4/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I4/I5.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I4/I6.jpeg?url").then(m => m.default),
    ],
    "BC": [
      () => import("@/assets/imgs/cabins/VE/BC/BC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/BC/BC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/BC/BC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/BC/BC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/BC/BC5.jpeg?url").then(m => m.default),
    ],
    "MS": [
      () => import("@/assets/imgs/cabins/VE/MS/MS1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/MS/MS2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/MS/MS3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/MS/MS4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/MS/MS5.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/MS/MS6.jpeg?url").then(m => m.default),
    ],
    "I1": [
      () => import("@/assets/imgs/cabins/VE/I1/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I1/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I1/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I1/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I1/I5.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I1/I6.jpeg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/VE/BP/BP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/BP/BP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/BP/BP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/BP/BP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/BP/BP5.jpeg?url").then(m => m.default),
    ],
    "B1": [
      () => import("@/assets/imgs/cabins/VE/B1/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B1/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B1/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B1/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B1/B5.jpeg?url").then(m => m.default),
    ],
    "EC": [
      () => import("@/assets/imgs/cabins/VE/EC/EC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/EC/EC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/EC/EC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/EC/EC4.jpeg?url").then(m => m.default),
    ],
    "IP": [
      () => import("@/assets/imgs/cabins/VE/IP/IP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IP/IP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IP/IP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IP/IP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IP/IP5.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IP/IP6.jpeg?url").then(m => m.default),
    ],
    "EV": [
      () => import("@/assets/imgs/cabins/VE/EV/EV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/EV/EV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/EV/EV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/EV/EV4.jpeg?url").then(m => m.default),
    ],
    "BV": [
      () => import("@/assets/imgs/cabins/VE/BV/BV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/BV/BV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/BV/BV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/BV/BV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/BV/BV5.jpeg?url").then(m => m.default),
    ],
    "I2": [
      () => import("@/assets/imgs/cabins/VE/I2/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I2/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I2/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I2/I4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I2/I5.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/I2/I6.jpeg?url").then(m => m.default),
    ],
    "IC": [
      () => import("@/assets/imgs/cabins/VE/IC/IC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IC/IC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IC/IC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IC/IC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IC/IC5.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/IC/IC6.jpeg?url").then(m => m.default),
    ],
    "B4": [
      () => import("@/assets/imgs/cabins/VE/B4/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B4/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B4/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B4/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/B4/B5.jpeg?url").then(m => m.default),
    ],
    "GS": [
      () => import("@/assets/imgs/cabins/VE/GS/S1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/GS/S2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/GS/S3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/GS/S4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/GS/S5.jpeg?url").then(m => m.default),
    ],
    "E2": [
      () => import("@/assets/imgs/cabins/VE/E2/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/E2/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/E2/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/VE/E2/E4.jpeg?url").then(m => m.default),
    ],
  },
  "FO": {
    "EP": [
      () => import("@/assets/imgs/cabins/FO/EP/EP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/EP/EP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/EP/EP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/EP/EP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/EP/EP5.jpeg?url").then(m => m.default),
    ],
    "I3": [
      () => import("@/assets/imgs/cabins/FO/I3/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/I3/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/I3/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/I3/I4.jpeg?url").then(m => m.default),
    ],
    "S": [
      () => import("@/assets/imgs/cabins/FO/S/S1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/S/S2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/S/S3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/S/S4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/S/S5.jpeg?url").then(m => m.default),
    ],
    "B2": [
      () => import("@/assets/imgs/cabins/FO/B2/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/B2/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/B2/B3.jpeg?url").then(m => m.default),
    ],
    "B3": [
      () => import("@/assets/imgs/cabins/FO/B3/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/B3/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/B3/B3.jpeg?url").then(m => m.default),
    ],
    "IV": [
      () => import("@/assets/imgs/cabins/FO/IV/IV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/IV/IV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/IV/IV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/IV/IV4.jpeg?url").then(m => m.default),
    ],
    "E1": [
      () => import("@/assets/imgs/cabins/FO/E1/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/E1/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/E1/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/E1/E4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/E1/E5.jpeg?url").then(m => m.default),
    ],
    "I4": [
      () => import("@/assets/imgs/cabins/FO/I4/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/I4/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/I4/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/I4/I4.jpeg?url").then(m => m.default),
    ],
    "BC": [
      () => import("@/assets/imgs/cabins/FO/BC/BC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/BC/BC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/BC/BC3.jpeg?url").then(m => m.default),
    ],
    "MS": [
      () => import("@/assets/imgs/cabins/FO/MS/MS1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/MS/MS2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/MS/MS3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/MS/MS4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/MS/MS5.jpeg?url").then(m => m.default),
    ],
    "I1": [
      () => import("@/assets/imgs/cabins/FO/I1/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/I1/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/I1/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/I1/I4.jpeg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/FO/BP/BP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/BP/BP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/BP/BP3.jpeg?url").then(m => m.default),
    ],
    "B1": [
      () => import("@/assets/imgs/cabins/FO/B1/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/B1/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/B1/B3.jpeg?url").then(m => m.default),
    ],
    "EC": [
      () => import("@/assets/imgs/cabins/FO/EC/EC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/EC/EC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/EC/EC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/EC/EC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/EC/EC5.jpeg?url").then(m => m.default),
    ],
    "IP": [
      () => import("@/assets/imgs/cabins/FO/IP/IP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/IP/IP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/IP/IP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/IP/IP4.jpeg?url").then(m => m.default),
    ],
    "EV": [
      () => import("@/assets/imgs/cabins/FO/EV/EV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/EV/EV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/EV/EV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/EV/EV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/EV/EV5.jpeg?url").then(m => m.default),
    ],
    "BV": [
      () => import("@/assets/imgs/cabins/FO/BV/BV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/BV/BV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/BV/BV3.jpeg?url").then(m => m.default),
    ],
    "I2": [
      () => import("@/assets/imgs/cabins/FO/I2/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/I2/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/I2/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/I2/I4.jpeg?url").then(m => m.default),
    ],
    "IC": [
      () => import("@/assets/imgs/cabins/FO/IC/IC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/IC/IC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/IC/IC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/IC/IC4.jpeg?url").then(m => m.default),
    ],
    "B4": [
      () => import("@/assets/imgs/cabins/FO/B4/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/B4/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/B4/B3.jpeg?url").then(m => m.default),
    ],
    "GS": [
      () => import("@/assets/imgs/cabins/FO/GS/GS1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/GS/GS2.jpg?url").then(m => m.default),
    ],
    "E2": [
      () => import("@/assets/imgs/cabins/FO/E2/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/E2/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/E2/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/E2/E4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/FO/E2/E5.jpeg?url").then(m => m.default),
    ],
  },
  "TO": {
    "EP": [
      () => import("@/assets/imgs/cabins/TO/EP/EP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/EP/EP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/EP/EP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/EP/EP4.jpeg?url").then(m => m.default),
    ],
    "I3": [
      () => import("@/assets/imgs/cabins/TO/I3/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/I3/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/I3/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/I3/I4.jpeg?url").then(m => m.default),
    ],
    "S": [
      () => import("@/assets/imgs/cabins/TO/S/S1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/S/S2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/S/S3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/S/S4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/S/S5.jpeg?url").then(m => m.default),
    ],
    "B2": [
      () => import("@/assets/imgs/cabins/TO/B2/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B2/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B2/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B2/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B2/B5.jpeg?url").then(m => m.default),
    ],
    "B3": [
      () => import("@/assets/imgs/cabins/TO/B3/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B3/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B3/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B3/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B3/B5.jpeg?url").then(m => m.default),
    ],
    "IV": [
      () => import("@/assets/imgs/cabins/TO/IV/IV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/IV/IV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/IV/IV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/IV/IV4.jpeg?url").then(m => m.default),
    ],
    "E1": [
      () => import("@/assets/imgs/cabins/TO/E1/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/E1/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/E1/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/E1/E4.jpeg?url").then(m => m.default),
    ],
    "I4": [
      () => import("@/assets/imgs/cabins/TO/I4/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/I4/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/I4/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/I4/I4.jpeg?url").then(m => m.default),
    ],
    "BC": [
      () => import("@/assets/imgs/cabins/TO/BC/BC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/BC/BC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/BC/BC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/BC/BC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/BC/BC5.jpeg?url").then(m => m.default),
    ],
    "I1": [
      () => import("@/assets/imgs/cabins/TO/I1/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/I1/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/I1/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/I1/I4.jpeg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/TO/BP/BP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/BP/BP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/BP/BP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/BP/BP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/BP/BP5.jpeg?url").then(m => m.default),
    ],
    "TP": [
      () => import("@/assets/imgs/cabins/TO/TP/TP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/TP/TP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/TP/TP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/TP/TP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/TP/TP5.jpeg?url").then(m => m.default),
    ],
    "B1": [
      () => import("@/assets/imgs/cabins/TO/B1/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B1/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B1/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B1/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B1/B5.jpeg?url").then(m => m.default),
    ],
    "EC": [
      () => import("@/assets/imgs/cabins/TO/EC/EC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/EC/EC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/EC/EC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/EC/EC4.jpeg?url").then(m => m.default),
    ],
    "IP": [
      () => import("@/assets/imgs/cabins/TO/IP/IP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/IP/IP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/IP/IP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/IP/IP4.jpeg?url").then(m => m.default),
    ],
    "TV": [
      () => import("@/assets/imgs/cabins/TO/TV/TV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/TV/TV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/TV/TV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/TV/TV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/TV/TV5.jpeg?url").then(m => m.default),
    ],
    "EV": [
      () => import("@/assets/imgs/cabins/TO/EV/EV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/EV/EV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/EV/EV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/EV/EV4.jpeg?url").then(m => m.default),
    ],
    "T1": [
      () => import("@/assets/imgs/cabins/TO/T1/T1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/T1/T2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/T1/T3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/T1/T4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/T1/T5.jpeg?url").then(m => m.default),
    ],
    "BV": [
      () => import("@/assets/imgs/cabins/TO/BV/BV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/BV/BV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/BV/BV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/BV/BV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/BV/BV5.jpeg?url").then(m => m.default),
    ],
    "I2": [
      () => import("@/assets/imgs/cabins/TO/I2/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/I2/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/I2/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/I2/I4.jpeg?url").then(m => m.default),
    ],
    "IC": [
      () => import("@/assets/imgs/cabins/TO/IC/IC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/IC/IC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/IC/IC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/IC/IC4.jpeg?url").then(m => m.default),
    ],
    "B4": [
      () => import("@/assets/imgs/cabins/TO/B4/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B4/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B4/B3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B4/B4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/B4/B5.jpeg?url").then(m => m.default),
    ],
    "GS": [
      () => import("@/assets/imgs/cabins/TO/GS/GS1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/GS/GS2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/GS/GS3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/GS/GS4.jpg?url").then(m => m.default),
    ],
    "E2": [
      () => import("@/assets/imgs/cabins/TO/E2/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/E2/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/E2/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/E2/E4.jpeg?url").then(m => m.default),
    ],
    "T2": [
      () => import("@/assets/imgs/cabins/TO/T2/T1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/T2/T2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/T2/T3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/T2/T4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/T2/T5.jpeg?url").then(m => m.default),
    ],
    "TC": [
      () => import("@/assets/imgs/cabins/TO/TC/TC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/TC/TC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/TC/TC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/TC/TC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/TO/TC/TC5.jpeg?url").then(m => m.default),
    ],
  },
  "DE": {
    "EP": [
      () => import("@/assets/imgs/cabins/DE/EP/EP1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/EP/EP2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/EP/EP3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/EP/EP4.jpg?url").then(m => m.default),
    ],
    "I3": [
      () => import("@/assets/imgs/cabins/DE/I3/I1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I3/I2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I3/I3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I3/I4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I3/I5.jpg?url").then(m => m.default),
    ],
    "S": [
      () => import("@/assets/imgs/cabins/DE/S/S1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/S/S2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/S/S3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/S/S4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/S/S5.jpg?url").then(m => m.default),
    ],
    "B2": [
      () => import("@/assets/imgs/cabins/DE/B2/B1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B2/B2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B2/B3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B2/B4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B2/B5.jpg?url").then(m => m.default),
    ],
    "B3": [
      () => import("@/assets/imgs/cabins/DE/B3/B1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B3/B2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B3/B3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B3/B4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B3/B5.jpg?url").then(m => m.default),
    ],
    "IV": [
      () => import("@/assets/imgs/cabins/DE/IV/IV1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/IV/IV2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/IV/IV3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/IV/IV4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/IV/IV5.jpg?url").then(m => m.default),
    ],
    "E1": [
      () => import("@/assets/imgs/cabins/DE/E1/E1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/E1/E2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/E1/E3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/E1/E4.jpg?url").then(m => m.default),
    ],
    "I4": [
      () => import("@/assets/imgs/cabins/DE/I4/I1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I4/I2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I4/I3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I4/I4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I4/I5.jpg?url").then(m => m.default),
    ],
    "BC": [
      () => import("@/assets/imgs/cabins/DE/BC/BC1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/BC/BC2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/BC/BC3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/BC/BC4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/BC/BC5.jpg?url").then(m => m.default),
    ],
    "MS": [
      () => import("@/assets/imgs/cabins/DE/MS/MS1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/MS/MS2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/MS/MS3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/MS/MS4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/MS/MS5.jpg?url").then(m => m.default),
    ],
    "I1": [
      () => import("@/assets/imgs/cabins/DE/I1/I1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I1/I2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I1/I3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I1/I4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I1/I5.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/DE/BP/BP1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/BP/BP2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/BP/BP3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/BP/BP4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/BP/BP5.jpg?url").then(m => m.default),
    ],
    "B1": [
      () => import("@/assets/imgs/cabins/DE/B1/B1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B1/B2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B1/B3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B1/B4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B1/B5.jpg?url").then(m => m.default),
    ],
    "EC": [
      () => import("@/assets/imgs/cabins/DE/EC/EC1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/EC/EC2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/EC/EC3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/EC/EC4.jpg?url").then(m => m.default),
    ],
    "IP": [
      () => import("@/assets/imgs/cabins/DE/IP/IP1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/IP/IP2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/IP/IP3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/IP/IP4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/IP/IP5.jpg?url").then(m => m.default),
    ],
    "EV": [
      () => import("@/assets/imgs/cabins/DE/EV/EV1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/EV/EV2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/EV/EV3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/EV/EV4.jpg?url").then(m => m.default),
    ],
    "BV": [
      () => import("@/assets/imgs/cabins/DE/BV/BV1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/BV/BV2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/BV/BV3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/BV/BV4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/BV/BV5.jpg?url").then(m => m.default),
    ],
    "I2": [
      () => import("@/assets/imgs/cabins/DE/I2/I1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I2/I2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I2/I3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I2/I4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/I2/I5.jpg?url").then(m => m.default),
    ],
    "IC": [
      () => import("@/assets/imgs/cabins/DE/IC/IC1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/IC/IC2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/IC/IC3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/IC/IC4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/IC/IC5.jpg?url").then(m => m.default),
    ],
    "B4": [
      () => import("@/assets/imgs/cabins/DE/B4/B1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B4/B2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B4/B3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B4/B4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/B4/B5.jpg?url").then(m => m.default),
    ],
    "GS": [
      () => import("@/assets/imgs/cabins/DE/GS/GS1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/GS/GS2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/GS/GS3.jpg?url").then(m => m.default),
    ],
    "E2": [
      () => import("@/assets/imgs/cabins/DE/E2/E1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/E2/E2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/E2/E3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/DE/E2/E4.jpg?url").then(m => m.default),
    ],
  },
  "MSC_MA": {
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_MA/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MA/BA/2.jpg?url").then(m => m.default),
    ],
    "OO": [
      () => import("@/assets/imgs/cabins/MSC_MA/OO/1.jpg?url").then(m => m.default),
    ],
    "IM2": [
      () => import("@/assets/imgs/cabins/MSC_MA/IM2/1.jpg?url").then(m => m.default),
    ],
    "SR1": [
      () => import("@/assets/imgs/cabins/MSC_MA/SR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MA/SR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MA/SR1/3.jpg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_MA/BR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MA/BR2/2.jpg?url").then(m => m.default),
    ],
    "IM1": [
      () => import("@/assets/imgs/cabins/MSC_MA/IM1/1.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_MA/IB/1.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_MA/OB/1.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_MA/SL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MA/SL1/2.jpg?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_MA/BR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MA/BR1/2.jpg?url").then(m => m.default),
    ],
    "SL2": [
      () => import("@/assets/imgs/cabins/MSC_MA/SL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MA/SL2/2.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_MA/BP/1.jpg?url").then(m => m.default),
    ],
    "M1": [
      () => import("@/assets/imgs/cabins/MSC_MA/M1/1.jpg?url").then(m => m.default),
    ],
    "BM2": [
      () => import("@/assets/imgs/cabins/MSC_MA/BM2/1.jpg?url").then(m => m.default),
    ],
    "BL1": [
      () => import("@/assets/imgs/cabins/MSC_MA/BL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MA/BL1/2.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_MA/BB/1.jpg?url").then(m => m.default),
    ],
    "BM1": [
      () => import("@/assets/imgs/cabins/MSC_MA/BM1/1.jpg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_MA/OR1/1.jpg?url").then(m => m.default),
    ],
  },
  "MSC_MU": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_MU/IR1/1.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_MU/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MU/BA/2.jpg?url").then(m => m.default),
    ],
    "OO": [
      () => import("@/assets/imgs/cabins/MSC_MU/OO/1.jpg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_MU/BR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MU/BR2/2.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_MU/IR2/1.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_MU/IB/1.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_MU/OB/1.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_MU/SL1/1.jpg?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_MU/BR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MU/BR1/2.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_MU/BP/1.jpg?url").then(m => m.default),
    ],
    "BL1": [
      () => import("@/assets/imgs/cabins/MSC_MU/BL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_MU/BL1/2.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_MU/BB/1.jpg?url").then(m => m.default),
    ],
    "OR2": [
      () => import("@/assets/imgs/cabins/MSC_MU/OR2/1.jpg?url").then(m => m.default),
    ],
    "BL2": [
      () => import("@/assets/imgs/cabins/MSC_MU/BL2/1.jpg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_MU/OR1/1.jpg?url").then(m => m.default),
    ],
  },
  "MSC_SV": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_SV/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/IR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/IR1/I_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/IR1/I_2.jpeg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_SV/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BA/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BA/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BA/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BA/B_2.jpeg?url").then(m => m.default),
    ],
    "SR1": [
      () => import("@/assets/imgs/cabins/MSC_SV/SR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SR1/SR1.png?url").then(m => m.default),
    ],
    "SD": [
      () => import("@/assets/imgs/cabins/MSC_SV/SD/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SD/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SD/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SD/SD1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SD/SD2.jpeg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_SV/YCT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YCT/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YCT/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YCT/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YCT/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YCT/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YCT/YC3_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YCT/YC3_2.jpeg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_SV/BR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR2/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR2/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR2/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR2/B_2.jpeg?url").then(m => m.default),
    ],
    "SX": [
      () => import("@/assets/imgs/cabins/MSC_SV/SX/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SX/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SX/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SX/SX_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SX/SX_2.jpeg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_SV/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YC1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YC1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YC1/YC1_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YC1/YC1_2.jpeg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_SV/YC3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YC3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YC3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YC3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YC3/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YC3/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YC3/YC3_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YC3/YC3_2.jpeg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_SV/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/IR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/IR2/I_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/IR2/I_2.jpeg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_SV/IB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/IB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/IB/I_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/IB/I_2.jpeg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_SV/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/OB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/OB/O_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/OB/O_2.jpeg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_SV/SL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SL1/SL1.png?url").then(m => m.default),
    ],
    "SLT": [
      () => import("@/assets/imgs/cabins/MSC_SV/SLT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SLT/SLT.png?url").then(m => m.default),
    ],
    "BR3": [
      () => import("@/assets/imgs/cabins/MSC_SV/BR3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR3/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR3/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR3/B_2.jpeg?url").then(m => m.default),
    ],
    "IL1": [
      () => import("@/assets/imgs/cabins/MSC_SV/IL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/IL1/IL1.png?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_SV/BR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR1/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR1/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR1/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR1/B_2.jpeg?url").then(m => m.default),
    ],
    "SLW": [
      () => import("@/assets/imgs/cabins/MSC_SV/SLW/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SLW/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SLW/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SLW/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SLW/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SLW/SLW1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SLW/SLW2.jpeg?url").then(m => m.default),
    ],
    "SM": [
      () => import("@/assets/imgs/cabins/MSC_SV/SM/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SM/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SM/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SM/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SM/SM1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/SM/SM2.jpeg?url").then(m => m.default),
    ],
    "BGA": [
      () => import("@/assets/imgs/cabins/MSC_SV/BGA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BGA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BGA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BGA/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BGA/BGA_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BGA/BGA_2.jpeg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_SV/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BB/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BB/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BB/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BB/B_2.jpeg?url").then(m => m.default),
    ],
    "BR4": [
      () => import("@/assets/imgs/cabins/MSC_SV/BR4/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR4/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR4/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR4/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR4/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR4/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/BR4/B_2.jpeg?url").then(m => m.default),
    ],
    "YIN": [
      () => import("@/assets/imgs/cabins/MSC_SV/YIN/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YIN/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YIN/YIN_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/YIN/YIN_2.jpeg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_SV/OR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/OR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/OR1/O_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SV/OR1/O_2.jpeg?url").then(m => m.default),
    ],
  },
  "MSC_GR": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_GR/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/IR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/IR1/3.jpg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_GR/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BA/4.jpg?url").then(m => m.default),
    ],
    "OO": [
      () => import("@/assets/imgs/cabins/MSC_GR/OO/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OO/2.jpg?url").then(m => m.default),
    ],
    "OM2": [
      () => import("@/assets/imgs/cabins/MSC_GR/OM2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OM2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OM2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OM2/4.jpg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_GR/YCT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YCT/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YCT/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YCT/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YCT/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YCT/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YCT/7.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YCT/8.jpg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_GR/BR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BR2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BR2/4.jpg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_GR/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YC1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YC1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YC1/4.jpg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_GR/YC3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YC3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YC3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YC3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YC3/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YC3/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YC3/7.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YC3/8.jpg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_GR/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/IR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/IR2/3.jpg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_GR/IB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/IB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/IB/3.jpg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_GR/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OB/4.jpg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_GR/SL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/SL1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/SL1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/SL1/sl1_premium_suite_aurea_expandible_desktop_700x433_square.jpg?url").then(m => m.default),
    ],
    "BR3": [
      () => import("@/assets/imgs/cabins/MSC_GR/BR3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BR3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BR3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BR3/4.jpg?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_GR/BR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BR1/4.jpg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/MSC_GR/BP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BP/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BP/4.jpg?url").then(m => m.default),
    ],
    "IS": [
      () => import("@/assets/imgs/cabins/MSC_GR/IS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/IS/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/IS/3.jpg?url").then(m => m.default),
    ],
    "SLJ": [
      () => import("@/assets/imgs/cabins/MSC_GR/SLJ/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/SLJ/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/SLJ/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/SLJ/slj_premium_suite_aurea_with_terrace_and_whirlpool_expandible_dextop_700x433_square.jpg?url").then(m => m.default),
    ],
    "BS": [
      () => import("@/assets/imgs/cabins/MSC_GR/BS/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BS/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BS/3.jpg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_GR/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/BB/4.jpg?url").then(m => m.default),
    ],
    "SXJ": [
      () => import("@/assets/imgs/cabins/MSC_GR/SXJ/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/SXJ/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/SXJ/SXJ.jpg?url").then(m => m.default),
    ],
    "YJD": [
      () => import("@/assets/imgs/cabins/MSC_GR/YJD/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YJD/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YJD/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YJD/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YJD/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YJD/6.jpg?url").then(m => m.default),
    ],
    "OL2": [
      () => import("@/assets/imgs/cabins/MSC_GR/OL2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OL2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OL2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OL2/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OL2/5.jpg?url").then(m => m.default),
    ],
    "YIN": [
      () => import("@/assets/imgs/cabins/MSC_GR/YIN/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YIN/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YIN/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/YIN/4.jpg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_GR/OR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_GR/OR1/4.jpg?url").then(m => m.default),
    ],
  },
  "MSC_SC": {
    "IR1": [
      () => import("@/assets/imgs/cabins/MSC_SC/IR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/IR1/I_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/IR1/I_2.jpeg?url").then(m => m.default),
    ],
    "BA": [
      () => import("@/assets/imgs/cabins/MSC_SC/BA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BA/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BA/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BA/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BA/B_2.jpeg?url").then(m => m.default),
    ],
    "SR1": [
      () => import("@/assets/imgs/cabins/MSC_SC/SR1/1.jpg?url").then(m => m.default),
    ],
    "SD": [
      () => import("@/assets/imgs/cabins/MSC_SC/SD/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SD/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SD/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SD/SD1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SD/SD2.jpeg?url").then(m => m.default),
    ],
    "YCT": [
      () => import("@/assets/imgs/cabins/MSC_SC/YCT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YCT/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YCT/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YCT/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YCT/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YCT/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YCT/YC3_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YCT/YC3_2.jpeg?url").then(m => m.default),
    ],
    "BR2": [
      () => import("@/assets/imgs/cabins/MSC_SC/BR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR2/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR2/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR2/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR2/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR2/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR2/B_2.jpeg?url").then(m => m.default),
    ],
    "SX": [
      () => import("@/assets/imgs/cabins/MSC_SC/SX/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SX/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SX/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SX/SX_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SX/SX_2.jpeg?url").then(m => m.default),
    ],
    "YCP": [
      () => import("@/assets/imgs/cabins/MSC_SC/YCP/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YCP/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YCP/3.jpg?url").then(m => m.default),
    ],
    "YC1": [
      () => import("@/assets/imgs/cabins/MSC_SC/YC1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC1/YC1_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC1/YC1_2.jpeg?url").then(m => m.default),
    ],
    "YC3": [
      () => import("@/assets/imgs/cabins/MSC_SC/YC3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC3/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC3/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC3/YC3_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC3/YC3_2.jpeg?url").then(m => m.default),
    ],
    "IR2": [
      () => import("@/assets/imgs/cabins/MSC_SC/IR2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/IR2/I_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/IR2/I_2.jpeg?url").then(m => m.default),
    ],
    "IB": [
      () => import("@/assets/imgs/cabins/MSC_SC/IB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/IB/I_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/IB/I_2.jpeg?url").then(m => m.default),
    ],
    "OB": [
      () => import("@/assets/imgs/cabins/MSC_SC/OB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/OB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/OB/O_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/OB/O_2.jpeg?url").then(m => m.default),
    ],
    "SL1": [
      () => import("@/assets/imgs/cabins/MSC_SC/SL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SL1/SL1.png?url").then(m => m.default),
    ],
    "SLT": [
      () => import("@/assets/imgs/cabins/MSC_SC/SLT/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SLT/SLT.png?url").then(m => m.default),
    ],
    "BR3": [
      () => import("@/assets/imgs/cabins/MSC_SC/BR3/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR3/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR3/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR3/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR3/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR3/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR3/B_2.jpeg?url").then(m => m.default),
    ],
    "IL1": [
      () => import("@/assets/imgs/cabins/MSC_SC/IL1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/IL1/IL1.png?url").then(m => m.default),
    ],
    "BR1": [
      () => import("@/assets/imgs/cabins/MSC_SC/BR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR1/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR1/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR1/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR1/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR1/B_2.jpeg?url").then(m => m.default),
    ],
    "YC2": [
      () => import("@/assets/imgs/cabins/MSC_SC/YC2/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC2/2.jpg?url").then(m => m.default),
    ],
    "SLW": [
      () => import("@/assets/imgs/cabins/MSC_SC/SLW/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SLW/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SLW/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SLW/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SLW/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SLW/SLW1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SLW/SLW2.jpeg?url").then(m => m.default),
    ],
    "SM": [
      () => import("@/assets/imgs/cabins/MSC_SC/SM/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SM/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SM/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SM/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SM/SM1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/SM/SM2.jpeg?url").then(m => m.default),
    ],
    "BGA": [
      () => import("@/assets/imgs/cabins/MSC_SC/BGA/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BGA/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BGA/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BGA/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BGA/BGA_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BGA/BGA_2.jpeg?url").then(m => m.default),
    ],
    "BB": [
      () => import("@/assets/imgs/cabins/MSC_SC/BB/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BB/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BB/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BB/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BB/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BB/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BB/B_2.jpeg?url").then(m => m.default),
    ],
    "YC4": [
      () => import("@/assets/imgs/cabins/MSC_SC/YC4/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC4/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC4/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC4/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC4/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC4/6.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC4/7.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC4/8.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YC4/YC4.jpeg?url").then(m => m.default),
    ],
    "BR4": [
      () => import("@/assets/imgs/cabins/MSC_SC/BR4/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR4/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR4/3.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR4/4.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR4/5.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR4/B_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/BR4/B_2.jpeg?url").then(m => m.default),
    ],
    "YIN": [
      () => import("@/assets/imgs/cabins/MSC_SC/YIN/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YIN/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YIN/YIN_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/YIN/YIN_2.jpeg?url").then(m => m.default),
    ],
    "OR1": [
      () => import("@/assets/imgs/cabins/MSC_SC/OR1/1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/OR1/2.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/OR1/O_1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/MSC_SC/OR1/O_2.jpeg?url").then(m => m.default),
    ],
  },
  "PA": {
    "EP": [
      () => import("@/assets/imgs/cabins/PA/EP/EP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/EP/EP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/EP/EP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/EP/EP4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/EP/EP5.jpeg?url").then(m => m.default),
    ],
    "I3": [
      () => import("@/assets/imgs/cabins/PA/I3/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/I3/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/I3/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/I3/I4.jpeg?url").then(m => m.default),
    ],
    "S": [
      () => import("@/assets/imgs/cabins/PA/S/S1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/S/S2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/S/S3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/S/S4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/S/S5.jpeg?url").then(m => m.default),
    ],
    "B2": [
      () => import("@/assets/imgs/cabins/PA/B2/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/B2/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/B2/B3.jpeg?url").then(m => m.default),
    ],
    "B3": [
      () => import("@/assets/imgs/cabins/PA/B3/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/B3/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/B3/B3.jpeg?url").then(m => m.default),
    ],
    "IV": [
      () => import("@/assets/imgs/cabins/PA/IV/IV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/IV/IV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/IV/IV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/IV/IV4.jpeg?url").then(m => m.default),
    ],
    "E1": [
      () => import("@/assets/imgs/cabins/PA/E1/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/E1/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/E1/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/E1/E4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/E1/E5.jpeg?url").then(m => m.default),
    ],
    "I4": [
      () => import("@/assets/imgs/cabins/PA/I4/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/I4/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/I4/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/I4/I4.jpeg?url").then(m => m.default),
    ],
    "BC": [
      () => import("@/assets/imgs/cabins/PA/BC/BC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/BC/BC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/BC/BC3.jpeg?url").then(m => m.default),
    ],
    "MS": [
      () => import("@/assets/imgs/cabins/PA/MS/MS1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/MS/MS2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/MS/MS3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/MS/MS4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/MS/MS5.jpeg?url").then(m => m.default),
    ],
    "I1": [
      () => import("@/assets/imgs/cabins/PA/I1/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/I1/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/I1/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/I1/I4.jpeg?url").then(m => m.default),
    ],
    "BP": [
      () => import("@/assets/imgs/cabins/PA/BP/BP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/BP/BP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/BP/BP3.jpeg?url").then(m => m.default),
    ],
    "B1": [
      () => import("@/assets/imgs/cabins/PA/B1/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/B1/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/B1/B3.jpeg?url").then(m => m.default),
    ],
    "EC": [
      () => import("@/assets/imgs/cabins/PA/EC/EC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/EC/EC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/EC/EC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/EC/EC4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/EC/EC5.jpeg?url").then(m => m.default),
    ],
    "IP": [
      () => import("@/assets/imgs/cabins/PA/IP/IP1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/IP/IP2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/IP/IP3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/IP/IP4.jpeg?url").then(m => m.default),
    ],
    "EV": [
      () => import("@/assets/imgs/cabins/PA/EV/EV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/EV/EV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/EV/EV3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/EV/EV4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/EV/EV5.jpeg?url").then(m => m.default),
    ],
    "BV": [
      () => import("@/assets/imgs/cabins/PA/BV/BV1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/BV/BV2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/BV/BV3.jpeg?url").then(m => m.default),
    ],
    "I2": [
      () => import("@/assets/imgs/cabins/PA/I2/I1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/I2/I2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/I2/I3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/I2/I4.jpeg?url").then(m => m.default),
    ],
    "IC": [
      () => import("@/assets/imgs/cabins/PA/IC/IC1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/IC/IC2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/IC/IC3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/IC/IC4.jpeg?url").then(m => m.default),
    ],
    "B4": [
      () => import("@/assets/imgs/cabins/PA/B4/B1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/B4/B2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/B4/B3.jpeg?url").then(m => m.default),
    ],
    "GS": [
      () => import("@/assets/imgs/cabins/PA/GS/GS1.jpg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/GS/GS2.jpg?url").then(m => m.default),
    ],
    "E2": [
      () => import("@/assets/imgs/cabins/PA/E2/E1.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/E2/E2.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/E2/E3.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/E2/E4.jpeg?url").then(m => m.default),
      () => import("@/assets/imgs/cabins/PA/E2/E5.jpeg?url").then(m => m.default),
    ],
  },
};
